import Vue from "vue";
import { jsPDF } from "jspdf";
import { GlobalStore } from "../globalStore";
import { formattingMethods } from "../helpers/formatting";

export const clientPDF = new Vue({
         data() {
           return {
             formModel: {
               insuranceStart: "",
               insuranceEnd: "",
               insuredName: "John Smith",
               insuredABN: "12345678901",
               businessActivity: "Test Business Activity",
               contactName: "Alex Barry",
               contactEmail: "alex@kora.net.au",
               contactPhone: "0434432808",
               businessAddress: "123",
               businessStreet: "test stree",
               businessCity: "test city",
               businessState: "Victoria",
               businessPostcode: "3113",
               associatedEntities: "test entity1, test entity 2",
               stampDutyStatus: "",
               changedTradingNames: null,
               otherTradingNames: "",
               currentBroker: "",
               timeWithBroker: "",
               currentInsurer: "",
               timeWithInsurer: "",
               policyExpiration: "",
               claimsExperience: [[], [], [], [], []],
               largestSingleClaim: "",
               largeLossesDetail: "",
               hadCriminalOffences: false,
               hadInsuranceRejected: false,
               hadInsuranceRejectedFraudDishonesty: false,
               needsHistoryExplanation: false,
               historyExplanation: "",
               averageDriverEmployment: "",
               hasDriverInductionTrainingProcedures: false,
               hasVehicleCareProcedures: false,
               hadFoulLicenses: false,
               conductsLicenceChecks: false,
               hasInexperiencedDrivers: false,
               hasSubcontractorDrivers: false,
               inMiningIndustry: false,
               vehiclesOnRails: false,
               vehiclesUsedInAirfield: false,
               vehiclesCarryDangerousGoods: false,
               vehiclesOverWeight: false,
               vehicleNightStorage: "",
               haveLaneDepartureWaring: false,
               haveReverseCamera: false,
               havePhoneConnectivity: false,
               roadworthy: false,
               percentageYoungDrivers: "",
               maxSingleVehicleValue: "",
               totalFleetValue: "",
               vehicleSchedule: [[], [], [], [], [], [], [], [], [], []]
             }
           };
         },
         methods: {
           doBodyTitleAndText(doc, pageConfig, title, text) {
             doc.setFontSize(9);
             doc.setFont("helvetica", "bold");

             //console.log(doc.getFont());

             doc.text(title, 10, pageConfig.currentYpos, {
               maxWidth: pageConfig.contentWidth
             });
             pageConfig.currentYpos += 4;
             doc.setFont("helvetica", "normal");
             doc.text(text, 10, pageConfig.currentYpos, {
               maxWidth: pageConfig.contentWidth - 5
             });
           },
           doHeader(doc, pageConfig) {
             doc.setFillColor("#f2f2f2");
             const headerHeight = 35;
             doc.rect(0, 0, pageConfig.pageWidth, headerHeight, "F");
           },
           doFooter(doc, pageConfig, pageNUmberText) {
             doc.setFillColor("#929292");
             doc.setFontSize(8);

             const footerHeight = 30;
             doc.rect(
               0,
               297 - footerHeight,
               pageConfig.pageWidth,
               footerHeight,
               "F"
             );

             doc.setTextColor("#FFFFFF");

             doc.text(
               "Mercurien Insurance Pty Ltd ABN 68 150 845 177, AFSL No 480284 Level 4, \nStone and Chalk. 11 York Street, Sydney NSW 2000\nt) 1800 00 2010 e) support@mercurien.com w) mercurien.com\n\nMercurien Insurance Pty Ltd acts under a binding authority on behalf of HDI\nGlobal Specialty SE – Australia ABN 58 129 395 544, AFSL 458776.",
               10,
               297 - footerHeight + 8,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "left"
               }
             );

             doc.text(
               "Version (v09/2021.2)\n\n\n\n\n" + pageNUmberText,
               pageConfig.contentWidth + 10,
               297 - footerHeight + 8,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "right"
               }
             );

             doc.setTextColor("#000000");
           },
           doRedHeading(doc, pageConfig, title, size) {
             doc.setFontSize(size);
             doc.setFont("helvetica", "bold");
             doc.setTextColor("#c20a08");

             //console.log(doc.getFont());

             doc.text(
               title,
               pageConfig.contentWidth / 2,
               pageConfig.currentYpos,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "center"
               }
             );
             pageConfig.currentYpos += 8;
             doc.setTextColor("#000000");
           },
           doHeading(doc, pageConfig, title, size) {
             doc.setFontSize(size);
             doc.setFont("helvetica", "bold");

             //console.log(doc.getFont());

             doc.text(
               title,
               pageConfig.contentWidth / 2 + 10,
               pageConfig.currentYpos,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "center"
               }
             );
             pageConfig.currentYpos += 4;
           },
           doTextHeading(
             doc,
             pageConfig,
             lefttitle,
             righttitle,
             size,
             style1,
             style2
           ) {
             doc.setFontSize(size);
             doc.setFont("helvetica", style1);

             doc.text(
               lefttitle,
               pageConfig.leftMargin + 2,
               pageConfig.currentYpos,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "left"
               }
             );

             doc.setFont("helvetica", style2);

             doc.text(
               righttitle,
               pageConfig.contentWidth - 2,
               pageConfig.currentYpos,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "right"
               }
             );
             pageConfig.currentYpos += 5;
           },
           doTitleAndValue(doc, pageConfig, title, value, additionalValue) {
             doc.setFontSize(10);
             doc.setFont("helvetica", "bold");

             //console.log(doc.getFont());

             doc.text(
               title,
               pageConfig.contentWidth / 2 - 37,
               pageConfig.currentYpos,
               {
                 maxWidth: pageConfig.contentWidth,
                 align: "right"
               }
             );
             doc.setFont("helvetica", "normal");
             doc.text(
               value,
               pageConfig.contentWidth / 2 - 30,
               pageConfig.currentYpos,
               {
                 maxWidth: 120,
                 align: "left"
               }
             );
             if (additionalValue) {
               doc.text(
                 additionalValue,
                 pageConfig.contentWidth / 2 + 10,
                 pageConfig.currentYpos,
                 {
                   maxWidth: 120,
                   align: "left"
                 }
               );
             }
             pageConfig.currentYpos += 7;
           },
           doTableHeader(doc, _config, columnDefs, ypos) {
             doc.rect(
               _config.leftMargin,
               ypos,
               _config.contentWidth,
               _config.tableRowHeight,
               "F"
             );
             doc.setFontSize(9);
             doc.setTextColor("#ffffff");

             let labelPos = 0;
             columnDefs.forEach((col, idx) => {
               const colOffset =
                 idx > 0
                   ? _config.contentWidth *
                     parseFloat(columnDefs[idx - 1].widthPercent / 100)
                   : 0;

               labelPos += colOffset;

               doc.text(col.label, _config.leftMargin + 2 + labelPos, ypos + 4);
             });
           },
           doTableRow(doc, _config, columnDefs, rowData, ypos) {
             doc.rect(
               _config.leftMargin,
               ypos,
               _config.contentWidth - 0.3,
               rowData.rowHeight
             );
             doc.setFontSize(9);
             doc.setTextColor("#000000");

             let linePos = 0;
             let labelPos = 0;

             columnDefs.forEach((col, idx) => {
               const colOffset =
                 idx > 0
                   ? _config.contentWidth *
                     parseFloat(columnDefs[idx - 1].widthPercent / 100)
                   : 0;

               const colWidth =
                 _config.contentWidth *
                 parseFloat(columnDefs[idx].widthPercent / 100);

               if (idx > 0) {
                 linePos += colOffset;
                 doc.line(
                   _config.leftMargin + linePos,
                   ypos,
                   _config.leftMargin + linePos,
                   ypos + rowData.rowHeight
                 );
               }

               labelPos += colOffset;

               doc.text(
                 rowData[col.id] || "",
                 _config.leftMargin + 2 + labelPos,
                 ypos + 4.5,
                 {
                   maxWidth: colWidth - 6
                 }
               );
             });
           },
           doTable(doc, pageConfig, columnDefs, data) {
             pageConfig.currentYpos += 7;
             this.doTableHeader(
               doc,
               pageConfig,
               columnDefs,
               pageConfig.currentYpos
             );

             pageConfig.currentYpos += pageConfig.tableRowHeight;

             data.forEach(rowData => {
               console.log(rowData);
               //columnDefs.forEach((col, idx) => {

               if (rowData.display) {
                 this.doTableRow(
                   doc,
                   pageConfig,
                   columnDefs,
                   rowData,
                   pageConfig.currentYpos
                 );
                 pageConfig.currentYpos += rowData.rowHeight - 0.1;
               }
               //});
             });

             // pageConfig.currentYpos += 6.9;
             // this.doTableRow(doc, pageConfig, pageConfig.currentYpos);
           },

          /**
          * Generates a pdf document from a html string.
          * @param {string} html html content
          * @returns {jsPDF} jsPDF instance
          */
          generateClaimPdf(data) {
          console.log("generating pdf from", data);
            const doc = new jsPDF();
            
            const pageConfig = {
              pageWidth: 210,
              contentWidth: 0,
              leftMargin: 10,
              rightMargin: 10,
              topMargin: 8,
              bottomMargin: 0,
              tableRowHeight: 7,
              currentYpos: 0
            };

            pageConfig.contentWidth =
              pageConfig.pageWidth -
              pageConfig.leftMargin -
              pageConfig.rightMargin;

            pageConfig.currentYpos += pageConfig.topMargin;

            this.doHeading(doc, pageConfig, "Claim Details", 15);

            pageConfig.currentYpos += 8;

            // Policyholder Details
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Business / Insured Name:",
              data.insuredName
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Policy Number:",
              data.policyNumber
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Contact Name:",
              data.contactName
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Contact Mobile Number:",
              data.contactPhone
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Contact Email:",
              data.contactEmail
            );
         
            // Policyholder Address
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Policyholder Address:",
              `${data.policyholderStreet} ${data.policyholderCity} ${data.policyholderState} ${data.policyholderPostcode}`
            );

            // Policy Details
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Date of damage or loss:",
              data.dateOfLoss
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Policy Number:",
              data.policyNumber
            );

            // GST
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Registered for 'GST':",
              `${data.registeredForGST ? "Yes" : "No"}`
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Insured ITC:",
              data.insuredITC
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Insured ABN:",
              data.abn
            );

            // Reported by
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Brokerage Name:",
              data.brokerageName
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "First Name:",
              data.reporterFName
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Last Name:",
              data.reporterLName
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Phone Number:",
              data.reporterPhone
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Email:",
              data.reporterEmail
            );

            // Incident details
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Date of Loss:",
              data.dateOfLoss
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Time of Loss:",
              data.timeOfLoss
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Estimate of Loss:",
              data.lossEstimate
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Details:",
              data.incidentDetail
            );

            doc.addPage()
            pageConfig.currentYpos = pageConfig.topMargin;
            
            // Incident Location
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Policyholder Address:",
              `${data.incidentStreet} ${data.incidentCity} ${data.incidentState} ${data.incidentPostcode}`
            );

            // Police Details
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Reported to Police:",
              `${data.reportedToPolice ? "Yes" : "No"}`
            );

            if (data.reportedToPolice) {
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Reference Number:",
                data.policeReportRef
              );
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Details:",
                data.policeReportDetails
              );
              pageConfig.currentYpos += 50;
            }

            // Bank account details
            pageConfig.currentYpos += 4;
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Account Name:",
              data.bankAccountName
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "BSB Number:",
              data.bankBSB
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Account Number:",
              data.bankAccountNumber
            );
            this.doTitleAndValue(
              doc,
              pageConfig,
              "Bank Name:",
              data.bankName
            );
      
            // Contact
            if (data.additionalContact) {
              doc.addPage("a4", "p");
              pageConfig.currentYpos = pageConfig.topMargin;
              
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Adding Additional contact:",
                `${data.additionalContact ? "Yes" : "No"}`
              );

              this.doTitleAndValue(
                doc,
                pageConfig,
                "Contact Type:",
                data.additionalContactType
              );

              this.doTitleAndValue(
                doc,
                pageConfig,
                "First Name:", 
                data.additionalContactFName
              );
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Last Name:",
                data.additionalContactLName
              );
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Telephone Number:",
                data.additionalContactTelephone
              );
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Mobile Number:",
                data.additionalContactMobile
              );
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Email:",
                data.additionalContactEmail
              );
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Preferred Contact:",
                data.additionalContactPreferredContact
              );
            } else {
              pageConfig.currentYpos += 4;
              this.doTitleAndValue(
                doc,
                pageConfig,
                "Adding Additional contact:",
                `${data.additionalContact ? "Yes" : "No"}`
              );
            }

            return doc;
          },

           /**
            * Generates the fleet information report
            * @param {object} fleetFormModel Fleet form model
            * @returns URI string of pfd
            */
           generateFleetPDF(fleetFormModel, fleetFrom) {
             this.formModel = fleetFormModel;

             const defaultPageWidth = 210;

             const pageConfig = {
               pageWidth: 210,
               contentWidth: 0,
               leftMargin: 10,
               rightMargin: 10,
               topMargin: 8,
               bottomMargin: 0,
               tableRowHeight: 7,
               currentYpos: 0
             };

             pageConfig.contentWidth =
               pageConfig.pageWidth -
               pageConfig.leftMargin -
               pageConfig.rightMargin;

             const doc = new jsPDF();

             //const pageWidth = 800;

             pageConfig.currentYpos += pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

              if (fleetFrom === 'rideshare') {
                doc.addImage(
                  "/img/brand/rideshare_fleet_logo.jpg",
                  "JPG",
                  100,
                  pageConfig.currentYpos,
                  100,
                  25
                );
              }

             doc.setFontSize(15);

             pageConfig.currentYpos += 37;

             if (fleetFrom === 'lightCommercial') {
              doc.text(
                "Mercurien Commercial Motor Insurance Proposal Form ",
                10,
                pageConfig.currentYpos
              );
 
              pageConfig.currentYpos += 6;
              doc.text("Version (v02/2022.1) ", 10, pageConfig.currentYpos);
             }

             const periodColumnDefs = [
               {
                 label: "Period of Insurance",
                 widthPercent: 40,
                 id: "periodTitle"
               },
               {
                 label: "",
                 widthPercent: 60,
                 id: "periodText"
               }
             ];

             /**** Period of Insurance Section */

             const periodData = [
               {
                 periodTitle: "Period of Insurance",
                 periodText:
                   "From 4pm AEST on " +
                   this.formModel.insuranceStart +
                   " to 4pm AEST on " +
                   this.formModel.insuranceEnd,
                 display: true,
                 rowHeight: 7
               }
             ];

             this.doTable(doc, pageConfig, periodColumnDefs, periodData);

             pageConfig.currentYpos += 3;

             /**** Business Details */

             const businessDetailsColumnDefs = [
               {
                 label: "Business Details",
                 widthPercent: 40,
                 id: "businessTitle"
               },
               {
                 label: "",
                 widthPercent: 60,
                 id: "businessText"
               }
             ];

             const businessDetailsData = [
               {
                 businessTitle: "Name of Insured",
                 businessText: this.formModel.insuredName,
                 display: true,
                 rowHeight: 7
               },
               {
                 businessTitle: "ABN",
                 businessText: this.formModel.insuredABN,
                 display: true,
                 rowHeight: 7
               },
               {
                 businessTitle: "Stamp Duty Status",
                 businessText: this.formModel.stampDutyStatus,
                 display: true,
                 rowHeight: 7
               },
               {
                 businessTitle: "Stamp Duty Exemption Reason",
                 businessText: this.formModel.stampDutyExceptionReason,
                 display: this.formModel.stampDutyStatus == "Exempt",
                 rowHeight: 7
               },
               {
                 businessTitle: "Business Address",
                 businessText:
                   this.formModel.businessStreet +
                   " " +
                   this.formModel.businessCity +
                   " " +
                   this.formModel.businessState +
                   " " +
                   this.formModel.businessPostcode,
                 display: true,
                 rowHeight: 7
               },
               {
                 businessTitle: "Other associated entities",
                 businessText: this.formModel.associatedEntities,
                 display: true,
                 rowHeight: 7
               },
               {
                 businessTitle:
                   "Precise Business activity: (including any anticipated/intended changes)",
                 businessText: this.formModel.businessActivity,
                 display: true,
                 rowHeight: 14
               },
               {
                 businessTitle:
                   "Have You changed trading names during the period in which You have been in business? (If Yes, please specify the last two trading names)",
                 businessText: this.formModel.changedTradingNames
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 14
               },
               {
                 businessTitle: "Preferred Contact Person",
                 businessText:
                   this.formModel.contactFName +
                   " " +
                   this.formModel.contactLName,
                 display: true,
                 rowHeight: 7
               },
               {
                 businessTitle: "Contact Mobile Number",
                 businessText: this.formModel.contactPhone,
                 display: true,
                 rowHeight: 7
               }
             ];

             this.doTable(
               doc,
               pageConfig,
               businessDetailsColumnDefs,
               businessDetailsData
             );

             pageConfig.currentYpos += 3;

             /**** Broker and Insurer Details */

             const brokerInsurerColumnDefs = [
               {
                 label: "Insurer Details",
                 widthPercent: 40,
                 id: "brokerInsurerTitle"
               },
               {
                 label: "",
                 widthPercent: 60,
                 id: "brokerInsurerText"
               }
             ];

             const brokerInsurerData = [
               // {
               //   brokerInsurerTitle: "Who is your current broker?",
               //   brokerInsurerText: this.formModel.currentBroker,
               //   display: true,
               //   rowHeight: 7
               // },
               // {
               //   brokerInsurerTitle: "How long have they acted for You?",
               //   brokerInsurerText: this.formModel.timeWithBroker,
               //   display: true,
               //   rowHeight: 7
               // },
               {
                 brokerInsurerTitle: "Who is Your current insurer?",
                 brokerInsurerText: this.formModel.currentInsurer,
                 display: true,
                 rowHeight: 7
               },
               {
                 brokerInsurerTitle:
                   "How long have You been insured with them?",
                 brokerInsurerText: this.formModel.timeWithInsurer,
                 display: true,
                 rowHeight: 7
               },
               {
                 brokerInsurerTitle: "When does Your current Policy expire?",
                 brokerInsurerText: this.formModel.policyExpiration,
                 display: true,
                 rowHeight: 7
               }
             ];

             this.doTable(
               doc,
               pageConfig,
               brokerInsurerColumnDefs,
               brokerInsurerData
             );

             doc.addPage("a4", "p");

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             if (fleetFrom === 'rideshare') {
              doc.addImage(
                "/img/brand/rideshare_fleet_logo.jpg",
                "PNG",
                100,
                pageConfig.currentYpos,
                100,
                25
              );
            }

             pageConfig.currentYpos += 27;

             /**** Claims experience */

             const claimsExperienceColumnDefs = [
               {
                 label: "Claims Experience",
                 widthPercent: 15,
                 id: "claimsExperiencePeriod"
               },
               {
                 label: "",
                 widthPercent: 25,
                 id: "claimsExperiencePeriodNoOfVehicles"
               },
               {
                 label: "",
                 widthPercent: 20,
                 id: "claimsExperiencePeriodExcess"
               },
               {
                 label: "",
                 widthPercent: 20,
                 id: "claimsExperiencePeriodNoOfClaims"
               },
               {
                 label: "",
                 widthPercent: 20,
                 id: "claimsExperiencePeriodIncurredClaimsCosts"
               }
             ];

             const claimsExperienceData = [
               {
                 claimsExperiencePeriod: "Period",
                 claimsExperiencePeriodNoOfVehicles: "No. Of Vehicles Operated",
                 claimsExperiencePeriodExcess: "Excess $",
                 claimsExperiencePeriodNoOfClaims: "No. Of Claims",
                 claimsExperiencePeriodIncurredClaimsCosts:
                   "Incurred Claims Costs",
                 display: true,
                 rowHeight: 7
               }
             ];

             for (let r = 0; r < 5; r++) {
               claimsExperienceData.push({
                 claimsExperiencePeriod: "Year " + (r + 1).toString(),
                 claimsExperiencePeriodNoOfVehicles:
                   this.formModel.claimsExperience[r][0] || "",
                 claimsExperiencePeriodExcess: this.formModel.claimsExperience[
                   r
                 ][1],
                 claimsExperiencePeriodNoOfClaims: this.formModel
                   .claimsExperience[r][2],
                 claimsExperiencePeriodIncurredClaimsCosts: this.formModel
                   .claimsExperience[r][3],
                 display: true,
                 rowHeight: 7
               });
             }

             this.doTable(
               doc,
               pageConfig,
               claimsExperienceColumnDefs,
               claimsExperienceData
             );

             /**** Claims experience - second bit */

             pageConfig.currentYpos -= pageConfig.tableRowHeight;

             const claimsExperience2ColumnDefs = [
               {
                 label: "",
                 widthPercent: 40,
                 id: "claimsExperience2Title"
               },
               {
                 label: "",
                 widthPercent: 60,
                 id: "claimsExperience2Value"
               }
             ];

             const claimsExperience2Data = [
               {
                 claimsExperience2Title: "What was the largest single claim?",
                 claimsExperience2Value: this.formModel.largestSingleClaim,
                 display: true,
                 rowHeight: 14
               },
               {
                 claimsExperience2Title:
                   "Please attach 5 years claims history on insurer letterhead.",
                 claimsExperience2Value: "Attached",
                 display: true,
                 rowHeight: 14
               },
               {
                 claimsExperience2Title:
                   "Please provide the details surrounding any individual losses greater than $75,000.",
                 claimsExperience2Value: this.formModel.largeLossesDetail,
                 display: true,
                 rowHeight: 14
               }
             ];

             this.doTable(
               doc,
               pageConfig,
               claimsExperience2ColumnDefs,
               claimsExperience2Data
             );

             /**** History */

             //pageConfig.currentYpos -= pageConfig.tableRowHeight;

             const claimsHistoryColumnDefs = [
               {
                 label:
                   "History (below questions relate to company, directors and/or drivers for the past 5 years)",
                 widthPercent: 90,
                 id: "claimsHistoryTitle"
               },
               {
                 label: "",
                 widthPercent: 10,
                 id: "claimsHistoryValue"
               }
             ];

             const claimsHistoryData = [
               {
                 claimsHistoryTitle:
                   "Been charged or convicted of any criminal offences?",
                 claimsHistoryValue: this.formModel.hadCriminalOffences
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 claimsHistoryTitle:
                   "Had any insurance declined, cancelled or refused (even if operating under a different entity)?",
                 claimsHistoryValue: this.formModel.hadInsuranceRejected
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 claimsHistoryTitle:
                   "Had an insurance claim rejected or declined due to fraud or dishonesty?",
                 claimsHistoryValue: this.formModel
                   .hadInsuranceRejectedFraudDishonesty
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 claimsHistoryTitle:
                   "Is there anything else that You need to tell us under Your Duty To Take Reasonable Care Not To Misrepresent?",
                 claimsHistoryValue: this.formModel.needsHistoryExplanation
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 14
               },
               {
                 claimsHistoryTitle:
                   "If Yes to any of the above, please provide details below:\n\n" +
                   this.formModel.historyExplanation,
                 claimsHistoryValue: "",
                 display: true,
                 rowHeight: 40
               }
             ];

             this.doTable(
               doc,
               pageConfig,
               claimsHistoryColumnDefs,
               claimsHistoryData
             );

             doc.addPage("a4", "p");

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             if (fleetFrom === 'rideshare') {
              doc.addImage(
                "/img/brand/rideshare_fleet_logo.jpg",
                "JPG",
                100,
                pageConfig.currentYpos,
                100,
                25
              );
            }

             pageConfig.currentYpos += 27;

             /**** Drivers */

             //pageConfig.currentYpos -= pageConfig.tableRowHeight;

             const driverColumnDefs = [
               {
                 label: "Drivers",
                 widthPercent: 85,
                 id: "driversTitle"
               },
               {
                 label: "",
                 widthPercent: 15,
                 id: "driversValue"
               }
             ];

             const driverHistoryData = [
               {
                 driversTitle:
                   "What is the average length of employment for drivers?",
                 driversValue: this.formModel.averageDriverEmployment,
                 display: true,
                 rowHeight: 7
               },
               {
                 driversTitle:
                   "Do You have driver induction & training procedures? (if Yes, please attach details)",
                 driversValue: this.formModel
                   .hasDriverInductionTrainingProcedures
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 driversTitle:
                   "Do You have documented Policies and procedures in place in respect to the use and care of company Vehicles? (if Yes, please attach details)",
                 driversValue: this.formModel.hasVehicleCareProcedures
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 14
               },
               {
                 driversTitle:
                   "Have any of Your drivers had their Driver’s Licence suspended, cancelled or restricted?",
                 driversValue: this.formModel.hadFoulLicenses ? "Yes" : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 driversTitle:
                   "Do You conduct Driver’s Licence and history checks prior to employment?",
                 driversValue: this.formModel.conductsLicenceChecks
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 driversTitle:
                   "Do or will You employ drivers under 23 years of age or with less than 2 years driving experience?",
                 driversValue: this.formModel.averageDriverEmployment
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 driversTitle: "Do or will You use sub-contractor drivers?",
                 driversValue: this.formModel.hasSubcontractorDrivers
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               }
             ];

             this.doTable(doc, pageConfig, driverColumnDefs, driverHistoryData);

             /**** Exposure */

             pageConfig.currentYpos += 4;

             const exposureColumnDefs = [
               {
                 label: "Exposure",
                 widthPercent: 85,
                 id: "exposureTitle"
               },
               {
                 label: "",
                 widthPercent: 15,
                 id: "exposureValue"
               }
             ];

             const exposureData = [
               {
                 exposureTitle:
                   "Are You or Your Vehicles linked, associated or used with the mining industry?",
                 exposureValue: this.formModel.inMiningIndustry ? "Yes" : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle: "Do any of Your Vehicles run on rails?",
                 exposureValue: this.formModel.vehiclesOnRails ? "Yes" : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "Are any of Your Vehicles used at an Airfield or Airside?",
                 exposureValue: this.formModel.vehiclesUsedInAirfield
                   ? "Yes"
                   : "No",
                 display: fleetFrom === 'lightCommercial',
                 rowHeight: 7
               },
               {
                exposureTitle:
                  "Are any vehicles used as a private charter/chauffeur?",
                exposureValue: this.formModel.vehiclesUsedAsCharter
                  ? "Yes"
                  : "No",
                display: fleetFrom === 'rideshare',
                rowHeight: 7
              },
               {
                 exposureTitle:
                   "Do any of Your Vehicles cart Dangerous Goods? (if Yes, separate form will be provided)",
                 exposureValue: this.formModel.vehiclesCarryDangerousGoods
                   ? "Yes"
                   : "No",
                 display: fleetFrom === 'lightCommercial',
                 rowHeight: 7
               },
               {
                exposureTitle:
                  "Are any of your vehicles used for Amazon Last Mile Delivery?",
                exposureValue: this.formModel.vehiclesUsedForAmazon
                  ? "Yes"
                  : "No",
                display: fleetFrom === 'rideshare',
                rowHeight: 7
              },
               {
                 exposureTitle:
                   "Does your schedule consist of any Vehicles over 3.5 tonnes? (if Yes, separate form will be provided)",
                 exposureValue: this.formModel.vehiclesOverWeight
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "Where are the majority of Vehicles in your fleet kept overnight?",
                 exposureValue: this.formModel.vehicleNightStorage,
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "Do the majority of Vehicles in Your fleet have a lane departure warning system? ",
                 exposureValue: this.formModel.haveLaneDepartureWaring
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "Do the majority of Vehicles in Your fleet have reverse cameras?",
                 exposureValue: this.formModel.haveReverseCamera ? "Yes" : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "Do the majority of Vehicles in Your fleet have handsfree and/or bluetooth connection capabilities for phones?",
                 exposureValue: this.formModel.havePhoneConnectivity
                   ? "Yes"
                   : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                exposureTitle:
                  "Do the majority of Vehicles in Your fleet have dash cams?",
                exposureValue: this.formModel.haveDashCams
                  ? "Yes"
                  : "No",
                display: fleetFrom === 'lightCommercial',
                rowHeight: 7
              },
               {
                 exposureTitle:
                   "Are Your Vehicles roadworthy for the state/territory they are being driven in?",
                 exposureValue: this.formModel.roadworthy ? "Yes" : "No",
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "What percentage of Your drivers are under 23 years of age?",
                 exposureValue: this.formModel.percentageYoungDrivers,
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "What is the maximum value of any one unit in Your Vehicle fleet?",
                 exposureValue:
                   "$" + (this.formModel.maxSingleVehicleValue || "0.00"),
                 display: true,
                 rowHeight: 7
               },
               {
                 exposureTitle:
                   "What is the maximum value of any one unit in Your Vehicle fleet?",
                 exposureValue:
                   "$" + (this.formModel.totalFleetValue || "0.00"),
                 display: true,
                 rowHeight: 7
               },
               {
                exposureTitle:
                  "What is the minimum lease of a vehicle?",
                exposureValue: this.formModel.minimumLease,
                display: fleetFrom === 'rideshare',
                rowHeight: 7
              }
             ];

             this.doTable(doc, pageConfig, exposureColumnDefs, exposureData);

             pageConfig.currentYpos += 4;

             /****** Excess */
             const excessColumnDefs = [
               {
                 label: "Excess",
                 widthPercent: 85,
                 id: "excessTitle"
               },
               {
                 label: "",
                 widthPercent: 15,
                 id: "excessValue"
               }
             ];

             const excessData = [
               {
                 excessTitle: "Excess Amount.",
                 excessValue: "$" + (this.formModel.excess || "0.00"),
                 display: true,
                 rowHeight: 7
               }
             ];

             this.doTable(doc, pageConfig, excessColumnDefs, excessData);

             doc.addPage("a4", "p");
             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );
             if (fleetFrom === 'rideshare') {
              doc.addImage(
                "/img/brand/rideshare_fleet_logo.jpg",
                "JPG",
                100,
                pageConfig.currentYpos,
                100,
                25
              );
            }

             pageConfig.currentYpos += 35;

             /****** vehicle schedule */

             const scheduleColumnDefs = [
               {
                 label: "Make",
                 widthPercent: 16.6,
                 id: "scheduleMake"
               },
               {
                 label: "Year",
                 widthPercent: 16.6,
                 id: "scheduleYear"
               },
               {
                 label: "Model",
                 widthPercent: 16.6,
                 id: "scheduleModel"
               },
               {
                 label: "Sum Insured",
                 widthPercent: 16.6,
                 id: "scheduleSumInsurer"
               },
               {
                 label: "State",
                 widthPercent: 16.6,
                 id: "scheduleState"
               },
               {
                 label: "Rego",
                 widthPercent: 16.6,
                 id: "scheduleRego"
               }
             ];

             const scheduleData = [];

             this.formModel.vehicleSchedule.forEach(row => {
               scheduleData.push({
                 scheduleMake: row[0],
                 scheduleYear: row[1],
                 scheduleModel: row[2],
                 scheduleState: row[3],
                 scheduleSumInsurer: row[4],
                 scheduleRego: row[5],
                 scheduleValue: this.formModel.inMiningIndustry ? "Yes" : "No",
                 display: true,
                 rowHeight: 7
               });
             });

             pageConfig.currentYpos += 4;
             doc.setFontSize(12);
             doc.text("Vehicle Schedule", 10, pageConfig.currentYpos);

             // If a schedule has been uploaded in the fleet form, adding text.
             if (sessionStorage.getItem("excelScheduleUploadFile")) {
               pageConfig.currentYpos += 4;
               doc.setFontSize(10);
               doc.text("See attached file.", 10, pageConfig.currentYpos);
             }

             pageConfig.currentYpos -= 3;

             this.doTable(doc, pageConfig, scheduleColumnDefs, scheduleData);

             doc.addPage("a4", "p");

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );
             if (fleetFrom === 'rideshare') {
              doc.addImage(
                "/img/brand/rideshare_fleet_logo.jpg",
                "JPG",
                100,
                pageConfig.currentYpos,
                100,
                25
              );
            }

             pageConfig.currentYpos += 35;

             doc.setFontSize(15);
             doc.text("Important Information", 10, pageConfig.currentYpos);

             pageConfig.currentYpos += 8;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `Your Duty to take Reasonable Care not to Misrepresent`,
               `You have a duty to take reasonable care not to make any misrepresentation when entering into, varying, extending or renewing the Policy. \n
This means that it is essential that You respond to specific questions that We ask honestly and to the best of Your knowledge, including where We ask You to confirm or update information that You have previously given to Us when entering into, varying, extending or renewing the Policy. \n
To assist You with providing Us with honest and accurate responses to any questions We ask of You, We have endeavoured to ensure that any questions We ask are clear and easy to understand. Further, where possible, We have also included examples of the types of responses We are looking for when asking a particular question. \n
If You are unclear of any particular question or would like Us to explain it to You, please get in touch with Us and We will explain this to You. \n
In determining whether You have fulfilled this duty to take reasonable care not to make a misrepresentation to Us, We will consider all of the relevant circumstances of a particular case. If You do not respond honestly and accurately to specific questions that We ask, We may (acting reasonably) cancel Your contract or reduce the 
amount We will pay You if You make a claim, or both. It is therefore vital that You be honest and specific in Your responses. If Your failure to tell Us is fraudulent, We will refuse to pay a claim and treat the Policy as if it never existed (this does not mean that We will refund any premiums that You have already paid).`
             );

             pageConfig.currentYpos += 80;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `If You do not tell Us something `,
               `If You do not tell Us anything You are required to, We may cancel Your Policy or reduce the amount We will pay You if You make a claim, or both. If Your failure to tell Us is fraudulent, We may refuse to pay a claim and treat the contract as if it never existed.`
             );

             pageConfig.currentYpos += 15;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `AGENT OF THE INSURER`,
               `In accordance with the requirements of the Corporations Act 2001, Mercurien Insurance, in arranging or effecting this insurance, or dealing with or settling claims will be acting under an authority given to it by HDI Global Specialty SE - Australia. Accordingly, Mercurien Insurance will be acting as an agent of the insurer and not an agent of You.`
             );

             pageConfig.currentYpos += 15;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `PRIVACY`,
               `Privacy legislation regulates the way private sector organisations can collect, use, keep secure and disclose personal information. Mercurien Insurance has developed a Privacy Policy, which explains what sort of personal information We hold about you and what we do with that information.`
             );

             pageConfig.currentYpos += 15;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `COMPLAINTS & DISPUTES RESOLUTION`,
               `If You have any complaints about the products or services provided to You, We have a complaints and internal dispute resolution process to try and resolve them as quickly as possible. Please click here for more information.`
             );

             pageConfig.currentYpos += 15;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `TARGET MARKET DETERMINATION`,
               `In accordance with the requirements of the Corporations Act 2001, Mercurien Insurance was required to prepare a Target Market Determination (TMD) outlining who our product is appropriate. Please click here for more information.  `
             );

             doc.addPage("a4", "p");

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );
             if (fleetFrom === 'rideshare') {
              doc.addImage(
                "/img/brand/rideshare_fleet_logo.jpg",
                "JPG",
                100,
                pageConfig.currentYpos,
                100,
                25
              );
            }

             pageConfig.currentYpos += 35;

             doc.setFontSize(15);
             doc.text("Declaration", 10, pageConfig.currentYpos);

             pageConfig.currentYpos += 12;

             this.doBodyTitleAndText(
               doc,
               pageConfig,
               `I/we acknowledge and declare that:\n`,
               `
1. I/We have received or have been offered a copy of the Combined Financial Services Guide and  Product Disclosure Statement/Policy Wording;

2. I/We have read the information concerning the Duty to take Reasonable Care not to Misrepresentand other Important Information;

3. I/We have been truthful and accurate in completing this form and declaration and have not withheld any information likely to affect the terms of the acceptance of this insurance by the Insurer;

4. I/We have completed this form personally or, if it has been completed on My/Our behalf, have checked that the questions have been fully and accurately answered;

5. Upon acceptance the terms and conditions of this insurance will be in accordance with the Product Disclosure Statement, Policy Wording and Schedule;

6. I/we have read and understood the Privacy information and consent to the collection, storage use and disclosure of any personal information;

7. An occurrence during the Period of Insurance, which alters any of the information provided, will be promptly notified;

8. If I/We have not complied with the Duty to take Reasonable Care not to Misrepresent, a claim made under the Policy may not be met or only met in part.`
             );

             var approvalText =
               GlobalStore.brokerObj.Broker_first_name +
               " " +
               GlobalStore.brokerObj.Broker_last_name +
               `, ` +
               GlobalStore.brokerObj.parentOrg.Broker_Org_Name +
               ` accepted T&Cs and submitted on ` +
               this.$moment(new Date()).format("Do of MMMM, YYYY") +
               `.`;

             console.log(approvalText);

             pageConfig.currentYpos += 90;

             doc.setFont("helvetica", "italic");
             //console.log(doc.getFont());

             doc.text(approvalText, 10, pageConfig.currentYpos, {
               maxWidth: pageConfig.contentWidth
             });

             // this.doBodyTitleAndText(
             //   doc,
             //   pageConfig,
             //   ``,
             //   `In accordance with the requirements of the Corporations Act 2001, Mercurien Insurance was required to prepare a Target Market Determination (TMD) outlining who our product is appropriate. Please click here for more information.  `
             // );

             //this.doBodyTitleAndText(doc, pageConfig, `Some text`);

             return doc.output("datauristring");
             // doc.save("fleet-form.pdf");
           },

           generateCOC(quoteModel) {
             // const quoteModel = {
             //   _id: { $oid: "62940f2abc10d89aba3e2d0b" },
             //   Customer_policy_id: { $numberDouble: "148.0" },
             //   Customer_policy_number: "",
             //   Customer_policy_guid: "b2f9b676-ecde-4678-9b68-29a2b1ad65be",
             //   Customer_id: { $numberInt: "13" },
             //   Customer_policy_status: "created",
             //   Customer_policy_start_date: "",
             //   Ubind_quote_id: "bfabdfc4-c498-488c-9ba1-7ee3e6d71c73",
             //   Ubind_customer_id: "59e7abb6-07c7-4642-a2a4-497f90232ab5",
             //   Broker_org_id: "brkOrg-0008",
             //   Insurance_broker_id: "insbrk-7",
             //   customer_policy_broker_referred_by: "Finlease Admin",
             //   Customer_policy_created_by: "62905c3dbc10d89abae56503",
             //   Ubind_status: "complete",
             //   Ubind_quote_last_updated_date: "2022-05-30T00:33:01.4300713Z",
             //   Ubind_quote_created_date: "2022-05-30T00:26:17Z",
             //   Ubind_quote_details_obj: {
             //     id: "bfabdfc4-c498-488c-9ba1-7ee3e6d71c73",
             //     policyId: "6b64f040-97ec-4b87-8ac7-360f3c71becf",
             //     quoteNumber: "TRKZVV",
             //     customerDetails: {
             //       id: "59e7abb6-07c7-4642-a2a4-497f90232ab5",
             //       displayName: "Demo Insured",
             //       isTestData: false,
             //       ownerUserId: "1469929e-c526-49c3-a3bb-9d7e40beb189"
             //     },
             //     productName: "Mercurien Commercial Motor",
             //     productId: "8f1597f3-ae7b-4c16-b1a3-63c5c5412756",
             //     tenantId: "4c2419fe-365d-462b-95e2-6ca590ea296e",
             //     status: "complete",
             //     policyNumber: "P-0048",
             //     policyOwnerUserId: "1469929e-c526-49c3-a3bb-9d7e40beb189",
             //     latestCalculationData: {
             //       calculationResultId: "d37f63fd-9ce6-4021-8279-b81776daf051",
             //       formDataId: "1a219fc7-3684-4810-ae09-d715f988e9d4",
             //       calculationResultJson:
             //         '{"state":"bindingQuote","questions":{"ratingPrimary":{"policyStartDateInput":"30/05/2022","numberOfVehicles":1,"companyName":"Demo Business PTY LTD","companyABN":"12345678910","streetAddressAllowSearch":false,"streetAddressAllowManualEntry":false,"streetAddressEnterManually":true,"streetAddress":"123A-123B Kilaben Road","streetSuburb":"KILABEN BAY","streetState":"NSW","streetPostcode":"2283","businessAddress":"123A-123B Kilaben Road KILABEN BAY NSW 2283","referrerURL":"https://partner-dev.yourinsurancehq.com.au/lightCommercial/createQuote?"},"ratingSecondary":{"brokerName":"Finlease Admin","brokerABN":"12345678910","brokerEmail":"finlease@yourinsurancehq.com.au","brokerPhone":"0409005950"},"dates":{"policyStartDate":"30/05/2022","policyEndDate":"30/05/2023"},"contact":{"contactFirstName":"Demo","contactLastName":"Insured","contactEmail":"demo.insured2022@gmail.com","contactPhone":"0409005950","contactName":"Demo Insured"},"getStarted":{},"details":{"fleetOverview":"No","vehicleUsePurpose":"Sales/Marketing","businessCategory":"G","searchAllActivities":false,"businessActivityCode":"39220","businessDescription":"Tyre retailing","anzsicGroup":"392 - Motor vehicle parts retailing","anzsicSubdivision":"39 - Motor vehicle and motor vehicle parts retailing","anzsicDivisionDescription":"Retail Trade","anzsicDividsion":"G"},"drivers":{"employeedDrivers":1,"driversUnder23Years":0,"driversLicenceStatusCheck":"They are checked one time per year","policyAndProceduresForVehicle":"Yes"},"vehicleDetails":{"vehicles":[{"searchVehicleBy":"Vehicle Registration","vehicleStateRegistered":"QLD","vehicleRegistration":"ACERT","regoSearchSelection":"2008 Toyota Landcruiser VDJ79R GXL Cab Chassis Single Cab 2dr Man 5sp 4x4 4.5DT","vehicleSumInsured":"15000","vehicleClassification":"Standard","vehicleValue":"15000","regoVehicleValueInput":15000,"vehicleAccessoriesType":"Standard","ownership":"Financed","interestedParties":"Commonwealth Bank","streetAddressAllowSearch":false,"streetAddressAllowManualEntry":false,"addressConfirmation":"Yes","streetAddressEnterManually":false,"vehicleAddressLocation":"Garage","vehicleValueCalculated":15000,"title":"Valid Trigger","redbookCode":"AUVTOYO2008AEHK","redbookRegoCode":"AUVTOYO2008AEHK","searchVehicleMake":"Toyota","searchVehicleFamily":"Landcruiser","searchVehicleYear":"2008","displayMake":"Toyota","displayModel":"Landcruiser","displayYear":"2008","highPoweredVehicle":"Not","vehicleRegistrationRego":"ACERT","vehicleType":"PS","vehicleStreetAddress":"123A-123B Kilaben Road","vehicleStreetSuburb":"KILABEN BAY","vehicleStreetState":"NSW","vehicleStreetPostcode":"2283"}]},"vehicleDetailsCont":{"vehicleTechReverseCamera":"Yes","vehicleTechCradelPhoneBluetooth":"Yes","vehicleTechLaneDeparture":"No","stateTerritoryVehicleRoadworthy":"Yes"},"policyOptions":{"windscreenCoverage":"No","hireCar":"No","excess":"1000","vehicleState":"NSW","classification":"Standard","under23Years":0,"vehicleAddressLocation":"Garage","contactAddressLine1":"123A-123B Kilaben Road","contactAddressSuburb":"KILABEN BAY","contactAddressState":"NSW","contactAddressPostcode":"2283","excessDisplay":"$1,000.00"},"taxCreditsFuel":{"fuelTaxCredits":"Yes"},"claimsHistory":{"registeredGST":"Yes","claimInputTaxCredits":"Yes","taxCreditPercentage":"100.00%","driversLicenceViolation":"No","criminalOffenseForDriverOrCompany":"No","insuranceDenialForDriverOrCompany":"No","hasClaimsHistory":"No","privacyStatement":"Yes","declaration":"Yes","totalFleetInOperation":0,"totalExcess":"$0.00","totalNumberIncurredClaims":0,"averageNumberIncurredClaims":0,"totalAmountIncurredClaims":"$0.00","totalFleetSize":0,"averageFleetSize":0,"moreThanTenVehicles":"No"},"summary":{},"paymentMethods":{"paymentMethodSelect":"Credit Card","installmentMonths":12,"paymentMethodInvoice":"No"},"paymentOptions":{"paymentOption":"Yearly","paymentMethod":"VISA"},"refundMethods":{},"purchaseCompleted":{},"agentDetails":{},"enquiry":{},"cancellation":{},"review":{"manualEndorsement":false},"referralAdjustments":{},"reviewMessage":{},"endorsement":{"alteredBasePremium":"$0.00"},"endorsementMessage":{},"statusVariables":{"variableUserType":"customer","variableUserHasAccount":"FALSE","variableCustomerHasAccount":"FALSE","variableQuoteHasCustomer":"TRUE","variableQuoteHadCustomerOnCreation":"FALSE","variableQuoteType":"newBusiness","variableQuoteState":"approved","variableFinancialTransactionType":"payment","variableReferrerURL":"https://partner-dev.yourinsurancehq.com.au/lightCommercial/continueQuote/b2f9b676-ecde-4678-9b68-29a2b1ad65be","variableApplicationURL":"https://app.ubind.com.au","variableAssetsFolderURL":"https://app.ubind.com.au/assets/mercurien/mercurien-light-commercial/staging","variableApplicationMode":"edit","variableProductEnvironment":"staging","variableCurrentWorkflowStep":"purchasePayment","variablePreviousWorkflowStep1":"purchaseSummary","variableOrganisationId":"finlease-fb2022","isOrganisationIdAllpoints":"No","isOrganisationIdHasYihq":"No","isOrganisationIdHasFb2022":"Yes","emailRecipientFrom":"noreply@ubind.io"}},"risk1":{"settings":{"riskName":"Premium","fieldCodePrefix":"S"},"ratingFactors":{"policyStartDate":"30/05/2022","policyEndDate":"30/05/2023","alteredBasePremium":0,"specialConditions":"","variableQuoteState":"approved","vehicleState":"NSW","vehicleUsePurpose":"Sales/Marketing","under23Years":0,"vehicleAddressLocation":"Garage","vehicleTechLaneDeparture":"No","vehicleTechReverseCamera":"Yes","vehicleTechCradelPhoneBluetooth":"Yes","windscreenCoverage":"No","hasClaimsHistory":"No","hireCar":"No","excess":"1000","fifthYearFromCurrentExcess":"","fifthYearFromCurrentIncurredNumberOfClaims":"","fifthYearFromCurrentIncurredAmountOfClaims":"","fourthYearFromCurrentExcess":"","fourthYearFromCurrentIncurredNumberOfClaims":"","fourthYearFromCurrentIncurredAmountOfClaims":"","thirdYearFromCurrentExcess":"","thirdYearFromCurrentIncurredNumberOfClaims":"","thirdYearFromCurrentIncurredAmountOfClaims":"","secondYearFromCurrentExcess":"","secondYearFromCurrentIncurredNumberOfClaims":"","secondYearFromCurrentIncurredAmountOfClaims":"","firstYearFromCurrentExcess":"","firstYearFromCurrentIncurredNumberOfClaims":"","firstYearFromCurrentIncurredAmountOfClaims":"","numberOfVehicles":1,"claimsDiscounts":"","variableQuoteType":"newBusiness","percentagePreviousYear":"","percentageAvgAdjustedClaim":"","percentageWeightMethod":"","percentageAvgCostOrClaim":"","percentageAvgCostOrVehicle":"","claimsRatio":"","lowClaimsDiscountsForLargeFleets":"","raterToUse":"","monthDrivexApp":"","monthDevice":"","deviceFeeDrivexApp":"","deviceFeeDevice":"","telematicsToUse":"","telematics":"","telematicsGST":"","roadside":"","roadsideGST":"","variableOrganisationId":"finlease-fb2022"},"loadingFactor":{"industryLoading":200,"under23YearsLoading":-20.1,"statesLoading":0,"parkedLocationLoading":-20,"laneDepartureLoading":10,"reverseCameraLoading":-16,"cradelLoading":-16,"windscreenLoading":0,"hireCarLoading":0,"totalLoading":137.9},"other":{"basePriceFixedComponent":0.75,"policyFee":30,"administrationFee":55,"excess":"1000","excessLoading":-0.1,"inflationRate":0.01,"raterToUse":2,"claimsYearFifth":"","totalExcess":0,"totalNumberIncurredClaims":0,"totalAmountIncurredClaims":0,"telematicsToUse":"driveX App","roadsideFee":65,"vehicleCoverCount":0},"checks":{"hasActiveReviewTrigger":false,"hasActiveEndorsementTrigger":false,"includeRisk":true,"newBasePremium":0},"display":{"vehicleItem":"1","vehicleYear":"2008","vehicleMake":"Toyota","vehicleModel":"Landcruiser","vehicleType":"","vehicleRego":"ACERT","vehicleSumInsured":"$15,000.00","vehicleInterestedParties":"Commonwealth Bank","feeLabel":"Administration Fee","endorsements":"","endorsementTitle1":"","endorsementSubTitle1":"","endorsementTexts1":"","endorsementTitle2":"","endorsementTexts2":"","endorsementTitle3":"","endorsementTexts3":"","specialConditionsTitle":"","specialConditionsTexts":"","displayFsl":"$0.00","displayRoadside":"$65.00","roadsideLabel":"driveX App - Roadside","displayAdminFee":"$55.00","displayAdminFeeGst":"$5.50","premiumExcludingMerchantFees":"$1,099.67","displayPolicyFee":"$30.00"},"mixAdjustment":{"lowClaimsDiscountsforLargeFleeet":0.05,"applyClaimforLargeFleets":"No"},"rateGuide":{"bandHighestValue":19000},"claimsRatingOnly":{"premiumPerstate":0,"FSL":0,"GSTonPremium&FSL":0,"SD":0,"policyFee":0,"gstonpolicyfee":0,"adminFee":0,"gstonadminfee":0,"total":0},"loadingRaterOnly":{"premiumPerstate":741.006,"FSL":0,"GSTonPremium&FSL":74.1006,"SD":73.359594,"policyFee":30,"gstonpolicyfee":3,"adminFee":55,"gstonadminfee":5.5,"total":981.966194},"loadingandLowClaimsAdjusted":{"premiumPerstate":703.9557,"FSL":0,"GSTonPremium&FSL":70.39557,"SD":69.6916143,"policyFee":30,"gstonpolicyfee":3,"adminFee":55,"gstonadminfee":5.5,"total":937.5428843},"brokerCommisionIncluded":{"premium":741.006,"FSL":0,"GST(Premium&FSL)":74.1006,"SD":73.359594,"policyFee":30,"GSTPolicyFee":3,"adminFee":55,"GSTadminFee":5.5,"total":981.966194,"brokerage(10%)":74.1006,"GSTonBrokerage":7.41006},"netofBrokerComms":{"premium":741.006,"lessBrokerFee":74.1006,"premiumlessBrokerFee":666.9054,"FSL":0,"GST(Premium&FSL)":66.69054,"SD":60.021486,"policyFee":30,"GSTPolicyFee":3,"adminFee":55,"GSTAdminFee":5.5,"total":887.117426},"telematics-SeparateInvoice":{"telematics-Standard":42,"GSTTelematics":4.2,"broker-Telematics(10%)":4.2,"GSTonBrokerage":0.42,"roadside":65,"GSTonRoadside":6.5},"statutoryRates":{"riskType":"General","ESLApplicability":"Not Applicable","jurisdiction":"NSW","policyStartDate":"30/05/2022","ESLRate":0,"GSTRate":0.1,"SDRateACT":0.02,"SDRateNSW":0.05,"SDRateNT":0.1,"SDRateQLD":0.09,"SDRateSA":0.11,"SDRateTAS":0.1,"SDRateVIC":0.1,"SDRateWA":0.1,"FSLRateNSW":0.005},"payment":{"premium":981.966194,"telematicsStandard":42,"GSTTelematics":4.2,"total":1028.166194}},"risk2":{"settings":{"riskName":"Else","fieldCodePrefix":"E"},"ratingFactors":{"vehicleState":"NSW","policyStartDate":"30/05/2022"},"checks":{"includeRisk":true},"premium":{"propertyCover":0,"travelCover":0,"basePremium":0,"premiumPercentACT":0,"premiumPercentNSW":1,"premiumPercentNT":0,"premiumPercentQLD":0,"premiumPercentSA":0,"premiumPercentTAS":0,"premiumPercentVIC":0,"premiumPercentWA":0},"other":{"something":"Val"},"statutoryRates":{"riskType":"Professional Indemnity","ESLApplicability":"Applicable","jurisdiction":"NSW","policyStartDate":"30/05/2022","ESLRate":0.3,"GSTRate":0.1,"SDRateACT":0,"SDRateNSW":0.05,"SDRateNT":0.1,"SDRateQLD":0.09,"SDRateSA":0.11,"SDRateTAS":0.1,"SDRateVIC":0.1,"SDRateWA":0.1},"payment":{"premium":0,"ESL":0,"GST":0,"SDACT":0,"SDNSW":0,"SDNT":0,"SDQLD":0,"SDSA":0,"SDTAS":0,"SDVIC":0,"SDWA":0,"total":0}},"triggers":{"review":{"totalAmountLessThanOne":false},"endorsement":{"moreThanOneClaim":false,"claimsDataProvided":false,"cumulativeClaimsRisk":false,"claimsTotalFleetSize":false,"vehicleNumber":false,"vehiceValueMoreThan150000":false,"driverAgeBetween20and24":false,"vehicleShape":false,"purposeOfVehicle":false,"vehiceValueMoreThanInsurableRange":false},"decline":{"purposeofVehicle":false,"driverDriveCompanyVehicle":false,"criminalOffenseForDriverOrCompany":false,"driverDriveCompanyVehicleWithOffense":false,"insuranceDenialForDriverOrCompany":false,"businessMining":false,"claimsHistory":false,"stateTerritoryVehicleRoadworthy":false,"vehicleMake":false},"error":{"noCoverSelected":false}},"payment":{"outputVersion":2,"priceComponents":{"basePremium":"$741.01","ESL":"$0.00","premiumGST":"$74.10","stampDutyACT":"$0.00","stampDutyNSW":"$73.36","stampDutyNT":"$0.00","stampDutyQLD":"$0.00","stampDutySA":"$0.00","stampDutyTAS":"$0.00","stampDutyVIC":"$0.00","stampDutyWA":"$0.00","stampDutyTotal":"$73.36","totalPremium":"$888.47","commission":"$74.10","commissionGST":"$7.41","brokerFee":"$85.00","brokerFeeGST":"$8.50","underwriterFee":"$107.00","underwriterFeeGST":"$10.70","interest":"$0.00","merchantFees":"4.39","transactionCosts":"$0.00","totalGST":"$93.30","totalPayable":"1104.06"},"instalments":{"instalmentsPerYear":"1","instalmentAmount":"1104.06"},"premiumFundingProposal":{"amountFunded":1099.666194,"interestRate":0.0696,"paymentFrequency":"Monthly","numberOfInstalments":10,"applicationFee":40,"initialInstalmentAmount":157.62029611024,"regularInstalmentAmount":117.62029611024}}}'
             //     },
             //     premiumData: {
             //       currencyCode: "AUD",
             //       basePremium: { $numberDouble: "741.01" },
             //       esl: { $numberDouble: "0.0" },
             //       premiumGst: { $numberDouble: "74.1" },
             //       stampDuty: { $numberDouble: "0.0" },
             //       stampDutyAct: { $numberDouble: "0.0" },
             //       stampDutyNsw: { $numberDouble: "73.36" },
             //       stampDutyNt: { $numberDouble: "0.0" },
             //       stampDutyQld: { $numberDouble: "0.0" },
             //       stampDutySa: { $numberDouble: "0.0" },
             //       stampDutyTas: { $numberDouble: "0.0" },
             //       stampDutyWa: { $numberDouble: "0.0" },
             //       stampDutyVic: { $numberDouble: "0.0" },
             //       commission: { $numberDouble: "74.1" },
             //       commissionGst: { $numberDouble: "7.41" },
             //       brokerFee: { $numberDouble: "85.0" },
             //       brokerFeeGst: { $numberDouble: "8.5" },
             //       underwriterFee: { $numberDouble: "107.0" },
             //       underwriterFeeGst: { $numberDouble: "10.7" },
             //       interest: { $numberDouble: "0.0" },
             //       merchantFees: { $numberDouble: "4.39" },
             //       transactionCosts: { $numberDouble: "0.0" },
             //       serviceFees: { $numberDouble: "0.0" },
             //       stampDutyTotal: { $numberDouble: "73.36" },
             //       totalPremium: { $numberDouble: "888.47" },
             //       totalGst: { $numberDouble: "93.3" },
             //       totalPayable: { $numberDouble: "1104.06" }
             //     },
             //     creationTimestamp: "2022-05-30T00:26:17Z",
             //     expiryTimestamp: null,
             //     lastModifiedTimestamp: "2022-05-30T00:33:01.4300713Z",
             //     owner: {
             //       id: "1469929e-c526-49c3-a3bb-9d7e40beb189",
             //       fullName: "Demo Broker"
             //     },
             //     quoteType: { $numberInt: "0" },
             //     displayableFieldsModel: {
             //       displayableFields: [
             //         "policyStartDateInput",
             //         "numberOfVehicles",
             //         "isCommonPolicyDueDate",
             //         "commonPolicyDueDate",
             //         "nextPolicyDueDate",
             //         "companyName",
             //         "companyABN",
             //         "streetAddress",
             //         "streetSuburb",
             //         "streetState",
             //         "streetPostcode",
             //         "businessAddress",
             //         "referrerURL",
             //         "brokerName",
             //         "brokerABN",
             //         "brokerEmail",
             //         "brokerPhone",
             //         "contactEmail",
             //         "contactPhone",
             //         "contactName",
             //         "fleetOverview",
             //         "overallFleetNumberOfVehicles",
             //         "overviewInsurancePolicyDueDate",
             //         "vehicleUsePurpose",
             //         "businessMining",
             //         "purposeOtherBusiness",
             //         "businessCategory",
             //         "searchAllActivities",
             //         "businessActivityCode",
             //         "businessDescription",
             //         "anzsicGroup",
             //         "anzsicSubdivision",
             //         "anzsicDivisionDescription",
             //         "anzsicDividsion",
             //         "employeedDrivers",
             //         "driversUnder23Years",
             //         "driversLicenceStatusCheck",
             //         "policyAndProceduresForVehicle",
             //         "vehicleTechReverseCamera",
             //         "vehicleTechCradelPhoneBluetooth",
             //         "vehicleTechLaneDeparture",
             //         "stateTerritoryVehicleRoadworthy",
             //         "windscreenCoverage",
             //         "hireCar",
             //         "excess",
             //         "vehicleState",
             //         "sumInsured",
             //         "classification",
             //         "under23Years",
             //         "vehicleAddressLocation",
             //         "contactAddressLine1",
             //         "contactAddressSuburb",
             //         "contactAddressState",
             //         "contactAddressPostcode",
             //         "excessDisplay",
             //         "fuelTaxCredits",
             //         "registeredGST",
             //         "claimInputTaxCredits",
             //         "taxCreditPercentage",
             //         "driversLicenceViolation",
             //         "criminalOffenseForDriverOrCompany",
             //         "driverDriveCompanyVehicleWithOffense",
             //         "insuranceDenialForDriverOrCompany",
             //         "hasClaimsHistory",
             //         "numberOfClaims",
             //         "fifthYearFromCurrentFleetInOperation",
             //         "fifthYearFromCurrentExcess",
             //         "fifthYearFromCurrentFleetSize",
             //         "fifthYearFromCurrentIncurredNumberOfClaims",
             //         "fifthYearFromCurrentIncurredAmountOfClaims",
             //         "fourthYearFromCurrentFleetInOperation",
             //         "fourthYearFromCurrentExcess",
             //         "fourthYearFromCurrentFleetSize",
             //         "fourthYearFromCurrentIncurredNumberOfClaims",
             //         "fourthYearFromCurrentIncurredAmountOfClaims",
             //         "thirdYearFromCurrentFleetInOperation",
             //         "thirdYearFromCurrentExcess",
             //         "thirdYearFromCurrentFleetSize",
             //         "thirdYearFromCurrentIncurredNumberOfClaims",
             //         "thirdYearFromCurrentIncurredAmountOfClaims",
             //         "secondYearFromCurrentFleetInOperation",
             //         "secondYearFromCurrentExcess",
             //         "secondYearFromCurrentFleetSize",
             //         "secondYearFromCurrentIncurredNumberOfClaims",
             //         "secondYearFromCurrentIncurredAmountOfClaims",
             //         "firstYearFromCurrentFleetInOperation",
             //         "firstYearFromCurrentExcess",
             //         "firstYearFromCurrentFleetSize",
             //         "firstYearFromCurrentIncurredNumberOfClaims",
             //         "firstYearFromCurrentIncurredAmountOfClaims",
             //         "claimsDocuments",
             //         "privacyStatement",
             //         "declaration",
             //         "totalClaimsProvided",
             //         "totalFleetInOperation",
             //         "totalExcess",
             //         "totalNumberIncurredClaims",
             //         "averageNumberIncurredClaims",
             //         "totalAmountIncurredClaims",
             //         "totalFleetSize",
             //         "averageFleetSize",
             //         "acceptanceConfirmation",
             //         "installmentMonths",
             //         "paymentMethodInvoice",
             //         "paymentMethod",
             //         "cancellationReason",
             //         "cancellationReasonOther",
             //         "cancellationCompetitorReason",
             //         "cancellationCompetitorReasonOther",
             //         "reviewMessage",
             //         "percentagePreviousYear",
             //         "percentageAvgAdjustedClaim",
             //         "percentageWeightMethod",
             //         "percentageAvgCostOrClaim",
             //         "percentageAvgCostOrVehicle",
             //         "claimsRatio",
             //         "lowClaimsDiscountsForLargeFleets",
             //         "raterToUse",
             //         "telematicsToUse",
             //         "monthDrivexApp",
             //         "monthDevice",
             //         "deviceFeeDrivexApp",
             //         "deviceFeeDevice",
             //         "telematics",
             //         "telematicsGST",
             //         "roadside",
             //         "roadsideGST",
             //         "scheduleOfVehicles",
             //         "claimsDiscounts",
             //         "specialConditions",
             //         "endorsementMessage"
             //       ],
             //       repeatingDisplayableFields: [
             //         "vehicles",
             //         "searchVehicleBy",
             //         "vehicleStateRegistered",
             //         "vehicleRegistration",
             //         "regoSearchSelection",
             //         "vehicleMakeInput",
             //         "vehicleModelInput",
             //         "vehicleYearInput",
             //         "vehicleShape",
             //         "vehicleEngine",
             //         "makeModelSearchSelection",
             //         "vehicleSumInsured",
             //         "vehicleClassification",
             //         "purchasePrice",
             //         "vehicleValue",
             //         "purchaseWithinThreeMonths",
             //         "vehicleValueInput",
             //         "redbookVehicleValueInput",
             //         "regoVehicleValueInput",
             //         "makeModelSearchRegoInput",
             //         "vehicleAccessoriesType",
             //         "optionalVehicleAccessories",
             //         "accessoriesPrice",
             //         "ownership",
             //         "interestedParties",
             //         "addressConfirmation",
             //         "streetAddress",
             //         "streetSuburb",
             //         "streetState",
             //         "streetPostcode",
             //         "vehicleAddressLocation",
             //         "vehicleCover",
             //         "validationTitle",
             //         "vehicleValueCalculated",
             //         "title",
             //         "redbookCode",
             //         "redbookRegoCode",
             //         "vehicleSpecsDescription",
             //         "privateMin",
             //         "tradeInMax",
             //         "searchVehicleMake",
             //         "searchVehicleFamily",
             //         "searchVehicleYear",
             //         "vehicleMakeCode",
             //         "vehicleFamilyCode",
             //         "vehicleYear",
             //         "vehicleMonth",
             //         "triggerMakeCode",
             //         "triggerFamilyCode",
             //         "triggerYear",
             //         "vehicleMakeSearchRBC",
             //         "highPoweredVehicle",
             //         "vfactsSegment",
             //         "vfactsPrice",
             //         "vehicleRegistrationRego",
             //         "vehicleType",
             //         "vehicleStreetAddress",
             //         "vehicleStreetSuburb",
             //         "vehicleStreetState",
             //         "vehicleStreetPostcode",
             //         "vehicleBodyType"
             //       ],
             //       displayableFieldsEnabled: true,
             //       repeatingDisplayableFieldsEnabled: true
             //     },
             //     isTestData: false,
             //     isDiscarded: false,
             //     formData: {
             //       ratingHeading: "",
             //       policyStartDateInput: "30/05/2022",
             //       insuredCompanyLabel: "",
             //       companyName: "Demo Business PTY LTD",
             //       companyABN: "12 345 678 910",
             //       manualEndorsementResetTimestamp: "",
             //       brokerLabel: "",
             //       brokerName: "Finlease Admin",
             //       brokerABN: "12 345 678 910",
             //       brokerEmail: "finlease@yourinsurancehq.com.au",
             //       brokerPhone: "0409 005 950",
             //       policyStartDate: "30/05/2022",
             //       policyEndDate: "30/05/2023",
             //       variableUserType: "customer",
             //       variableUserHasAccount: "False",
             //       variableCustomerHasAccount: "False",
             //       variableQuoteHasCustomer: "True",
             //       variableQuoteHadCustomerOnCreation: "false",
             //       variableQuoteType: "newBusiness",
             //       variableQuoteState: "approved",
             //       variableFinancialTransactionType: "payment",
             //       variableApplicationURL: "https://app.ubind.com.au",
             //       variableAssetsFolderURL:
             //         "https://app.ubind.com.au/assets/mercurien/mercurien-light-commercial/staging",
             //       variableApplicationMode: "edit",
             //       variableProductEnvironment: "staging",
             //       variablePreviousWorkflowStep2: "",
             //       variablePreviousWorkflowStep3: "",
             //       paymentOption: "Yearly",
             //       paymentMethod: "VISA",
             //       contactFirstName: "Demo",
             //       contactLastName: "Insured",
             //       contactEmail: "demo.insured2022@gmail.com",
             //       businessAddress: "123A-123B Kilaben Road KILABEN BAY NSW 2283",
             //       streetAddressEnterManually: "Yes",
             //       streetAddress: "123A-123B Kilaben Road",
             //       streetSuburb: "KILABEN BAY",
             //       streetState: "NSW",
             //       streetPostcode: "2283",
             //       contactName: "Demo Insured",
             //       contactPhone: "0409 005 950",
             //       numberOfVehicles: "1",
             //       referrerURL:
             //         "https://partner-dev.yourinsurancehq.com.au/lightCommercial/createQuote?",
             //       variableReferrerURL:
             //         "https://partner-dev.yourinsurancehq.com.au/lightCommercial/continueQuote/b2f9b676-ecde-4678-9b68-29a2b1ad65be",
             //       variableCurrentWorkflowStep: "purchasePayment",
             //       variablePreviousWorkflowStep1: "purchaseSummary",
             //       variableOrganisationId: "finlease-fb2022",
             //       isOrganisationIdAllpoints: "No",
             //       isOrganisationIdHasYihq: "No",
             //       isOrganisationIdHasFb2022: "Yes",
             //       emailRecipientFrom: "noreply@ubind.io",
             //       fleetOverview: "No",
             //       vehicleUsePurpose: "Sales/Marketing",
             //       businessCategory: "G",
             //       searchAllActivities: "No",
             //       businessActivityCode: "39220",
             //       businessDescription: "Tyre retailing",
             //       anzsicGroup: "392 - Motor vehicle parts retailing",
             //       anzsicSubdivision:
             //         "39 - Motor vehicle and motor vehicle parts retailing",
             //       anzsicDivisionDescription: "Retail Trade",
             //       anzsicDividsion: "G",
             //       employeedDrivers: "1",
             //       driversUnder23Years: "0",
             //       driversLicenceStatusCheck: "They are checked one time per year",
             //       policyAndProceduresForVehicle: "Yes",
             //       vehicles: [
             //         {
             //           searchVehicleBy: "Vehicle Registration",
             //           vehicleStateRegistered: "QLD",
             //           vehicleRegistration: "ACERT",
             //           regoSearchSelection:
             //             "2008 Toyota Landcruiser VDJ79R GXL Cab Chassis Single Cab 2dr Man 5sp 4x4 4.5DT",
             //           vehicleMakeInput: "",
             //           vehicleModelInput: "",
             //           vehicleYearInput: "",
             //           vehicleShape: "",
             //           vehicleEngine: "",
             //           vehicleSumInsured: "15000",
             //           vehicleClassification: "Standard",
             //           purchasePrice: "",
             //           vehicleValue: "15000",
             //           regoVehicleValueInput: "$15,000",
             //           vehicleAccessoriesType: "Standard",
             //           ownership: "Financed",
             //           interestedParties: "Commonwealth Bank",
             //           addressConfirmation: "Yes",
             //           streetAddress: "",
             //           streetSuburb: "",
             //           streetState: "",
             //           streetPostcode: "",
             //           vehicleAddressLocation: "Garage",
             //           validationTitle: "",
             //           vehicleValueCalculated: "$15,000",
             //           title: "Valid Trigger",
             //           redbookCode: "AUVTOYO2008AEHK",
             //           redbookRegoCode: "AUVTOYO2008AEHK",
             //           vehicleSpecsDescription: "",
             //           privateMin: "",
             //           tradeInMax: "",
             //           searchVehicleMake: "Toyota",
             //           searchVehicleFamily: "Landcruiser",
             //           searchVehicleYear: "2008",
             //           vehicleMakeCode: "",
             //           vehicleFamilyCode: "",
             //           vehicleYear: "",
             //           vehicleMonth: "",
             //           triggerMakeCode: "",
             //           triggerFamilyCode: "",
             //           triggerYear: "",
             //           vehicleMakeSearchRBC: "",
             //           displayMake: "Toyota",
             //           displayModel: "Landcruiser",
             //           displayYear: "2008",
             //           highPoweredVehicle: "Not",
             //           vfactsSegment: "",
             //           vfactsPrice: "",
             //           vehicleRegistrationRego: "ACERT",
             //           vehicleType: "PS",
             //           vehicleStreetAddress: "123A-123B Kilaben Road",
             //           vehicleStreetSuburb: "KILABEN BAY",
             //           vehicleStreetState: "NSW",
             //           vehicleStreetPostcode: "2283",
             //           vehicleBodyType: ""
             //         }
             //       ],
             //       vehicleTechReverseCamera: "Yes",
             //       vehicleTechCradelPhoneBluetooth: "Yes",
             //       vehicleTechLaneDeparture: "No",
             //       stateTerritoryVehicleRoadworthy: "Yes",
             //       windscreenCoverage: "No",
             //       hireCar: "No",
             //       excess: "1000",
             //       vehicleState: "NSW",
             //       sumInsured: "",
             //       classification: "Standard",
             //       under23Years: "0",
             //       vehicleAddressLocation: "Garage",
             //       contactAddressLine1: "123A-123B Kilaben Road",
             //       contactAddressSuburb: "KILABEN BAY",
             //       contactAddressState: "NSW",
             //       contactAddressPostcode: "2283",
             //       excessDisplay: "$1,000",
             //       fuelTaxCredits: "Yes",
             //       registeredGST: "Yes",
             //       claimInputTaxCredits: "Yes",
             //       taxCreditPercentage: "100%",
             //       driversLicenceViolation: "No",
             //       criminalOffenseForDriverOrCompany: "No",
             //       insuranceDenialForDriverOrCompany: "No",
             //       hasClaimsHistory: "No",
             //       privacyStatement: "Yes",
             //       declaration: "Yes",
             //       totalClaimsProvided: "",
             //       totalFleetInOperation: "0",
             //       totalExcess: "$0",
             //       totalNumberIncurredClaims: "0",
             //       averageNumberIncurredClaims: "0",
             //       totalAmountIncurredClaims: "$0",
             //       totalFleetSize: "0",
             //       averageFleetSize: "0",
             //       moreThanTenVehicles: "No",
             //       paymentMethodSelect: "Credit Card",
             //       debitOption: "",
             //       creditCardSelect: "",
             //       installmentMonths: "12",
             //       paymentMethodInvoice: "No"
             //     },
             //     questionData: {
             //       ratingPrimary: {
             //         policyStartDateInput: "30/05/2022",
             //         numberOfVehicles: { $numberInt: "1" },
             //         companyName: "Demo Business PTY LTD",
             //         companyABN: "12345678910",
             //         streetAddressAllowSearch: false,
             //         streetAddressAllowManualEntry: false,
             //         streetAddressEnterManually: true,
             //         streetAddress: "123A-123B Kilaben Road",
             //         streetSuburb: "KILABEN BAY",
             //         streetState: "NSW",
             //         streetPostcode: "2283",
             //         businessAddress: "123A-123B Kilaben Road KILABEN BAY NSW 2283",
             //         referrerURL:
             //           "https://partner-dev.yourinsurancehq.com.au/lightCommercial/createQuote?"
             //       },
             //       ratingSecondary: {
             //         brokerName: "Finlease Admin",
             //         brokerABN: "12345678910",
             //         brokerEmail: "finlease@yourinsurancehq.com.au",
             //         brokerPhone: "0409005950"
             //       },
             //       dates: {
             //         policyStartDate: "30/05/2022",
             //         policyEndDate: "30/05/2023"
             //       },
             //       contact: {
             //         contactFirstName: "Demo",
             //         contactLastName: "Insured",
             //         contactEmail: "demo.insured2022@gmail.com",
             //         contactPhone: "0409005950",
             //         contactName: "Demo Insured"
             //       },
             //       getStarted: {},
             //       details: {
             //         fleetOverview: "No",
             //         vehicleUsePurpose: "Sales/Marketing",
             //         businessCategory: "G",
             //         searchAllActivities: false,
             //         businessActivityCode: "39220",
             //         businessDescription: "Tyre retailing",
             //         anzsicGroup: "392 - Motor vehicle parts retailing",
             //         anzsicSubdivision:
             //           "39 - Motor vehicle and motor vehicle parts retailing",
             //         anzsicDivisionDescription: "Retail Trade",
             //         anzsicDividsion: "G"
             //       },
             //       drivers: {
             //         employeedDrivers: { $numberInt: "1" },
             //         driversUnder23Years: { $numberInt: "0" },
             //         driversLicenceStatusCheck: "They are checked one time per year",
             //         policyAndProceduresForVehicle: "Yes"
             //       },
             //       vehicleDetails: {
             //         vehicles: [
             //           {
             //             searchVehicleBy: "Vehicle Registration",
             //             vehicleStateRegistered: "QLD",
             //             vehicleRegistration: "ACERT",
             //             regoSearchSelection:
             //               "2008 Toyota Landcruiser VDJ79R GXL Cab Chassis Single Cab 2dr Man 5sp 4x4 4.5DT",
             //             vehicleSumInsured: "15000",
             //             vehicleClassification: "Standard",
             //             vehicleValue: "15000",
             //             regoVehicleValueInput: { $numberInt: "15000" },
             //             vehicleAccessoriesType: "Standard",
             //             ownership: "Financed",
             //             interestedParties: "Commonwealth Bank",
             //             streetAddressAllowSearch: false,
             //             streetAddressAllowManualEntry: false,
             //             addressConfirmation: "Yes",
             //             streetAddressEnterManually: false,
             //             vehicleAddressLocation: "Garage",
             //             vehicleValueCalculated: { $numberInt: "15000" },
             //             title: "Valid Trigger",
             //             redbookCode: "AUVTOYO2008AEHK",
             //             redbookRegoCode: "AUVTOYO2008AEHK",
             //             searchVehicleMake: "Toyota",
             //             searchVehicleFamily: "Landcruiser",
             //             searchVehicleYear: "2008",
             //             displayMake: "Toyota",
             //             displayModel: "Landcruiser",
             //             displayYear: "2008",
             //             highPoweredVehicle: "Not",
             //             vehicleRegistrationRego: "ACERT",
             //             vehicleType: "PS",
             //             vehicleStreetAddress: "123A-123B Kilaben Road",
             //             vehicleStreetSuburb: "KILABEN BAY",
             //             vehicleStreetState: "NSW",
             //             vehicleStreetPostcode: "2283"
             //           }
             //         ]
             //       },
             //       vehicleDetailsCont: {
             //         vehicleTechReverseCamera: "Yes",
             //         vehicleTechCradelPhoneBluetooth: "Yes",
             //         vehicleTechLaneDeparture: "No",
             //         stateTerritoryVehicleRoadworthy: "Yes"
             //       },
             //       policyOptions: {
             //         windscreenCoverage: "No",
             //         hireCar: "No",
             //         excess: "1000",
             //         vehicleState: "NSW",
             //         classification: "Standard",
             //         under23Years: { $numberInt: "0" },
             //         vehicleAddressLocation: "Garage",
             //         contactAddressLine1: "123A-123B Kilaben Road",
             //         contactAddressSuburb: "KILABEN BAY",
             //         contactAddressState: "NSW",
             //         contactAddressPostcode: "2283",
             //         excessDisplay: "$1,000.00"
             //       },
             //       taxCreditsFuel: { fuelTaxCredits: "Yes" },
             //       claimsHistory: {
             //         registeredGST: "Yes",
             //         claimInputTaxCredits: "Yes",
             //         taxCreditPercentage: "100.00%",
             //         driversLicenceViolation: "No",
             //         criminalOffenseForDriverOrCompany: "No",
             //         insuranceDenialForDriverOrCompany: "No",
             //         hasClaimsHistory: "No",
             //         privacyStatement: "Yes",
             //         declaration: "Yes",
             //         totalFleetInOperation: { $numberInt: "0" },
             //         totalExcess: "$0.00",
             //         totalNumberIncurredClaims: { $numberInt: "0" },
             //         averageNumberIncurredClaims: { $numberInt: "0" },
             //         totalAmountIncurredClaims: "$0.00",
             //         totalFleetSize: { $numberInt: "0" },
             //         averageFleetSize: { $numberInt: "0" },
             //         moreThanTenVehicles: "No"
             //       },
             //       summary: {},
             //       paymentMethods: {
             //         paymentMethodSelect: "Credit Card",
             //         installmentMonths: { $numberInt: "12" },
             //         paymentMethodInvoice: "No"
             //       },
             //       paymentOptions: { paymentOption: "Yearly", paymentMethod: "VISA" },
             //       refundMethods: {},
             //       purchaseCompleted: {},
             //       agentDetails: {},
             //       enquiry: {},
             //       cancellation: {},
             //       review: { manualEndorsement: false },
             //       referralAdjustments: {},
             //       reviewMessage: {},
             //       endorsement: { alteredBasePremium: "$0.00" },
             //       endorsementMessage: {},
             //       statusVariables: {
             //         variableUserType: "customer",
             //         variableUserHasAccount: "FALSE",
             //         variableCustomerHasAccount: "FALSE",
             //         variableQuoteHasCustomer: "TRUE",
             //         variableQuoteHadCustomerOnCreation: "FALSE",
             //         variableQuoteType: "newBusiness",
             //         variableQuoteState: "approved",
             //         variableFinancialTransactionType: "payment",
             //         variableReferrerURL:
             //           "https://partner-dev.yourinsurancehq.com.au/lightCommercial/continueQuote/b2f9b676-ecde-4678-9b68-29a2b1ad65be",
             //         variableApplicationURL: "https://app.ubind.com.au",
             //         variableAssetsFolderURL:
             //           "https://app.ubind.com.au/assets/mercurien/mercurien-light-commercial/staging",
             //         variableApplicationMode: "edit",
             //         variableProductEnvironment: "staging",
             //         variableCurrentWorkflowStep: "purchasePayment",
             //         variablePreviousWorkflowStep1: "purchaseSummary",
             //         variableOrganisationId: "finlease-fb2022",
             //         isOrganisationIdAllpoints: "No",
             //         isOrganisationIdHasYihq: "No",
             //         isOrganisationIdHasFb2022: "Yes",
             //         emailRecipientFrom: "noreply@ubind.io"
             //       }
             //     },
             //     documents: [
             //       {
             //         id: "925a2305-eb31-46ee-993a-b23058915bdf",
             //         quoteOrPolicyTransactionId:
             //           "f655133d-42bb-46ed-b344-67fd4ff54fc2",
             //         fileName: "Tax Invoice.pdf",
             //         mimeType: "application/octet-stream",
             //         fileSize: "379.39 KB",
             //         createdDate: "2022-05-30T00:33:13Z",
             //         dateGroupHeader: "30 May 2022"
             //       },
             //       {
             //         id: "18934592-eac4-4679-96c6-1905fc389f07",
             //         quoteOrPolicyTransactionId:
             //           "f655133d-42bb-46ed-b344-67fd4ff54fc2",
             //         fileName: "PDS Mercurien Insurance.pdf",
             //         mimeType: "application/octet-stream",
             //         fileSize: "447.61 KB",
             //         createdDate: "2022-05-30T00:33:13Z",
             //         dateGroupHeader: "30 May 2022"
             //       },
             //       {
             //         id: "6fcaa220-efe3-4566-8750-af1d93bce110",
             //         quoteOrPolicyTransactionId:
             //           "f655133d-42bb-46ed-b344-67fd4ff54fc2",
             //         fileName: "Certificate of Currency.pdf",
             //         mimeType: "application/octet-stream",
             //         fileSize: "318.37 KB",
             //         createdDate: "2022-05-30T00:33:13Z",
             //         dateGroupHeader: "30 May 2022"
             //       },
             //       {
             //         id: "46f957c6-b219-44a8-9a0a-2e44e041e58a",
             //         quoteOrPolicyTransactionId:
             //           "f655133d-42bb-46ed-b344-67fd4ff54fc2",
             //         fileName: "Policy Schedule.pdf",
             //         mimeType: "application/octet-stream",
             //         fileSize: "325.01 KB",
             //         createdDate: "2022-05-30T00:33:13Z",
             //         dateGroupHeader: "30 May 2022"
             //       }
             //     ],
             //     questionAttachmentKeys: ["claimsDocuments", "scheduleOfVehicles"],
             //     organisationId: "54d285da-5686-4174-95a5-f702b826a3c4",
             //     organisationName: "Finlease",
             //     additionalPropertyValues: []
             //   },
             //   Ubind_refNo: "TRKZVV"
             // };

             const defaultPageWidth = 210;

             const pageConfig = {
               pageWidth: 210,
               contentWidth: 0,
               leftMargin: 10,
               rightMargin: 10,
               topMargin: 7,
               bottomMargin: 0,
               tableRowHeight: 7,
               currentYpos: 0
             };

             pageConfig.contentWidth =
               pageConfig.pageWidth -
               pageConfig.leftMargin -
               pageConfig.rightMargin;

             const doc = new jsPDF();

             //const pageWidth = 800;

             pageConfig.currentYpos += pageConfig.topMargin;

             this.doHeader(doc, pageConfig);

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             pageConfig.currentYpos += 40;

             this.doHeading(doc, pageConfig, "CERTIFICATE OF CURRENCY", 16);

             pageConfig.currentYpos += 10;

             this.doTitleAndValue(
               doc,
               pageConfig,
               "DATE ISSUED:",
               quoteModel.Ubind_quote_details_obj.formData.policyStartDate
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "POLICY NO:",
               quoteModel.Ubind_quote_details_obj.policyNumber
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "INSURED:",
               quoteModel.Ubind_quote_details_obj.formData.companyName
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "BUSINESS:",
               quoteModel.Ubind_quote_details_obj.formData.businessDescription
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "INSURER:",
               "HDI Global Specialty SE – Australia ABN 58 129 395 544, AFSL 458776."
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "PERIOD OF INSURANCE:",
               `From: 4PM (AEST) on ${quoteModel.Ubind_quote_details_obj.formData.policyStartDate} To: 4PM (AEST) on ${quoteModel.Ubind_quote_details_obj.formData.policyEndDate}`
             );

             this.doRedHeading(
               doc,
               pageConfig,
               "SECTION 1 - YOUR VEHICLE COVER",
               10
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "SUM INSURED:",
               `Market Value (MV).`
             );

             this.doRedHeading(
               doc,
               pageConfig,
               "SECTION 2 - THIRD PARTY COVER",
               10
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "LIMIT OF LIABILITY:",
               `$20,000,000 any one event.`
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "DANGEROUS GOODS:",
               `$10,000 any one event.`
             );

             this.doRedHeading(
               doc,
               pageConfig,
               "EXCESS(ES) AND ENDORSEMENTS",
               10
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "STANDARD EXCESS",
               `$1,000 or 2% of Sum Insured over $100,000 each and every claim`
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "TELEMATICS EXCESS:",
               `If the driveX Roadside App has not been downloaded and in use in relation to the Vehicle(s) Insured within a 60 day period, and We have not agreed in writing otherwise, We may apply an additional Excess of $5,000 in the event of a claim. "Inuse", means the app is turned on and connected to the Vehicle to manage roadside. \n\nPlus applicable age and other Excesses as per Policy Wording.`
             );

             pageConfig.currentYpos += 30;

             this.doTitleAndValue(doc, pageConfig, "ENDORSEMENTS", ``);

             doc.addImage(
               "/img/policy-endorsement.png",
               "PNG",
               pageConfig.leftMargin + 15,
               pageConfig.currentYpos,
               90,
               38
             );

             this.doFooter(doc, pageConfig, "Page 1 of 2");

             doc.addPage("a4", "p");

             this.doHeader(doc, pageConfig);

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             pageConfig.currentYpos += 40;

             this.doHeading(doc, pageConfig, "SCHEDULE OF VEHICLES", 16);

             const scheduleColumnDefs = [
               {
                 label: "Item",
                 widthPercent: 10,
                 id: "item"
               },
               {
                 label: "Year",
                 widthPercent: 15,
                 id: "year"
               },
               {
                 label: "Model",
                 widthPercent: 15,
                 id: "model"
               },
               {
                 label: "Type",
                 widthPercent: 15,
                 id: "type"
               },

               {
                 label: "Rego",
                 widthPercent: 15,
                 id: "rego"
               },

               {
                 label: "Interested Parties",
                 widthPercent: 30,
                 id: "interestedParties"
               }
             ];

             const scheduleData = [];

             console.log(quoteModel.Ubind_quote_details_obj.formData);

             quoteModel.Ubind_quote_details_obj.formData.vehicles.forEach(
               (v, idx) => {
                 scheduleData.push({
                   item: (idx + 1).toString(),
                   year: v.displayYear,
                   make: v.displayMake,
                   model: v.displayModel,
                   type: "",
                   rego: v.vehicleRegistration,
                   interestedParties: v.interestedParties,
                   display: true,
                   rowHeight: 8
                 });
               }
             );

             // vehicles: [
             //   {
             //     searchVehicleBy: "Vehicle Registration",
             //     vehicleStateRegistered: "QLD",
             //     vehicleRegistration: "ACERT",
             //     regoSearchSelection:
             //       "2008 Toyota Landcruiser VDJ79R GXL Cab Chassis Single Cab 2dr Man 5sp 4x4 4.5DT",
             //     vehicleMakeInput: "",
             //     vehicleModelInput: "",
             //     vehicleYearInput: "",
             //     vehicleShape: "",
             //     vehicleEngine: "",
             //     vehicleSumInsured: "15000",
             //     vehicleClassification: "Standard",
             //     purchasePrice: "",
             //     vehicleValue: "15000",
             //     regoVehicleValueInput: "$15,000",
             //     vehicleAccessoriesType: "Standard",
             //     ownership: "Financed",
             //     interestedParties: "Commonwealth Bank",
             //     addressConfirmation: "Yes",
             //     streetAddress: "",
             //     streetSuburb: "",
             //     streetState: "",
             //     streetPostcode: "",
             //     vehicleAddressLocation: "Garage",
             //     validationTitle: "",
             //     vehicleValueCalculated: "$15,000",
             //     title: "Valid Trigger",
             //     redbookCode: "AUVTOYO2008AEHK",
             //     redbookRegoCode: "AUVTOYO2008AEHK",
             //     vehicleSpecsDescription: "",
             //     privateMin: "",
             //     tradeInMax: "",
             //     searchVehicleMake: "Toyota",
             //     searchVehicleFamily: "Landcruiser",
             //     searchVehicleYear: "2008",
             //     vehicleMakeCode: "",
             //     vehicleFamilyCode: "",
             //     vehicleYear: "",
             //     vehicleMonth: "",
             //     triggerMakeCode: "",
             //     triggerFamilyCode: "",
             //     triggerYear: "",
             //     vehicleMakeSearchRBC: "",
             //     displayMake: "Toyota",
             //     displayModel: "Landcruiser",
             //     displayYear: "2008",
             //     highPoweredVehicle: "Not",
             //     vfactsSegment: "",
             //     vfactsPrice: "",
             //     vehicleRegistrationRego: "ACERT",
             //     vehicleType: "PS",
             //     vehicleStreetAddress: "123A-123B Kilaben Road",
             //     vehicleStreetSuburb: "KILABEN BAY",
             //     vehicleStreetState: "NSW",
             //     vehicleStreetPostcode: "2283",
             //     vehicleBodyType: ""
             //   }

             // const businessDetailsData = [
             //   {
             //     businessTitle: "Name of Insured",
             //     businessText: this.formModel.insuredName,
             //     display: true,
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle: "ABN",
             //     businessText: this.formModel.insuredABN,
             //     display: true,
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle: "Stamp Duty Status",
             //     businessText: this.formModel.stampDutyStatus,
             //     display: true,
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle: "Stamp Duty Exemption Reason",
             //     businessText: this.formModel.stampDutyExceptionReason,
             //     display: this.formModel.stampDutyStatus == "Exempt",
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle: "Business Address",
             //     businessText:
             //       this.formModel.businessStreet +
             //       " " +
             //       this.formModel.businessCity +
             //       " " +
             //       this.formModel.businessState +
             //       " " +
             //       this.formModel.businessPostcode,
             //     display: true,
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle: "Other associated entities",
             //     businessText: this.formModel.associatedEntities,
             //     display: true,
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle:
             //       "Precise Business activity: (including any anticipated/intended changes)",
             //     businessText: this.formModel.businessActivity,
             //     display: true,
             //     rowHeight: 14
             //   },
             //   {
             //     businessTitle:
             //       "Have You changed trading names during the period in which You have been in business? (If Yes, please specify the last two trading names)",
             //     businessText: this.formModel.changedTradingNames ? "Yes" : "No",
             //     display: true,
             //     rowHeight: 14
             //   },
             //   {
             //     businessTitle: "Preferred Contact Person",
             //     businessText:
             //       this.formModel.contactFName + " " + this.formModel.contactLName,
             //     display: true,
             //     rowHeight: 7
             //   },
             //   {
             //     businessTitle: "Contact Mobile Number",
             //     businessText: this.formModel.contactPhone,
             //     display: true,
             //     rowHeight: 7
             //   }
             // ];

             this.doTable(doc, pageConfig, scheduleColumnDefs, scheduleData);

             this.doFooter(doc, pageConfig, "Page 2 of 2");

             //doc.save("certificate-of-currency.pdf");
             return doc;
           },

           generateSchedule(quoteModel) {
             const calculationResult = JSON.parse(
               quoteModel.Ubind_quote_details_obj.latestCalculationData
                 .calculationResultJson
             );

             const defaultPageWidth = 210;

             const pageConfig = {
               pageWidth: 210,
               contentWidth: 0,
               leftMargin: 10,
               rightMargin: 10,
               topMargin: 7,
               bottomMargin: 0,
               tableRowHeight: 7,
               currentYpos: 0
             };

             pageConfig.contentWidth =
               pageConfig.pageWidth -
               pageConfig.leftMargin -
               pageConfig.rightMargin;

             const doc = new jsPDF();

             //const pageWidth = 800;

             pageConfig.currentYpos += pageConfig.topMargin;

             this.doHeader(doc, pageConfig);

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             pageConfig.currentYpos += 40;

             this.doHeading(doc, pageConfig, "SCHEDULE", 16);

             pageConfig.currentYpos += 10;

             this.doTitleAndValue(
               doc,
               pageConfig,
               "DATE:",
               quoteModel.Ubind_quote_details_obj.formData.policyStartDate
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "INSURANCE:",
               "Commercial Motor Insurance"
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "POLICY NO:",
               quoteModel.Ubind_quote_details_obj.policyNumber
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "INSURED:",
               quoteModel.Ubind_quote_details_obj.formData.companyName
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "BUSINESS:",
               quoteModel.Ubind_quote_details_obj.formData.businessDescription
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "POLICY WORDING:",
               "Mercurien Commercial Motor Insurance PDS & Policy Wording (v09-2021.2)"
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "Base Premium",
               "$" + quoteModel.Ubind_quote_details_obj.premiumData.basePremium
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "Policy Fee",
               calculationResult.risk1.display.displayPolicyFee
             );

             console.log(calculationResult);

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "Administration Fee",
               calculationResult.risk1.display.displayAdminFee
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "FSL",
               calculationResult.risk1.display.displayFsl
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "PREMIUM",
               "Stamp Duty",
               calculationResult.payment.priceComponents.stampDutyTotal
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "driveX & Roadside",
               calculationResult.payment.priceComponents.underwriterFee
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "GST",
               calculationResult.payment.priceComponents.totalGST
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "",
               "TOTAL AMOUNT",
               calculationResult.risk1.display.premiumExcludingMerchantFees
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "INSURER:",
               "HDI Global Specialty SE – Australia ABN 58 129 395 544, AFSL 458776."
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "PERIOD OF INSURANCE:",
               `From: 4PM (AEST) on ${quoteModel.Ubind_quote_details_obj.formData.policyStartDate} To: 4PM (AEST) on ${quoteModel.Ubind_quote_details_obj.formData.policyEndDate}`
             );

             this.doRedHeading(
               doc,
               pageConfig,
               "SECTION 1 - YOUR VEHICLE COVER",
               10
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "SUM INSURED:",
               `Market Value (MV).`
             );

             this.doRedHeading(
               doc,
               pageConfig,
               "SECTION 2 - THIRD PARTY COVER",
               10
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "LIMIT OF LIABILITY:",
               `$20,000,000 any one event.`
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "DANGEROUS GOODS:",
               `$10,000 any one event.`
             );

             this.doRedHeading(
               doc,
               pageConfig,
               "EXCESS(ES) AND ENDORSEMENTS",
               10
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "STANDARD EXCESS",
               `$1,000 or 2% of Sum Insured over $100,000 each and every claim`
             );

             this.doTitleAndValue(
               doc,
               pageConfig,
               "TELEMATICS EXCESS:",
               `If the driveX Roadside App has not been downloaded and in use in relation to the Vehicle(s) Insured within a 60 day period, and We have not agreed in writing otherwise, We may apply an additional Excess of $5,000 in the event of a claim. "Inuse", means the app is turned on and connected to the Vehicle to manage roadside. \n\nPlus applicable age and other Excesses as per Policy Wording.`
             );

             this.doFooter(doc, pageConfig, "Page 1 of 3");

             //pageConfig.currentYpos += 30;

             doc.addPage("a4", "p");

             this.doHeader(doc, pageConfig);

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             pageConfig.currentYpos += 40;

             this.doTitleAndValue(doc, pageConfig, "ENDORSEMENTS", ``);

             doc.addImage(
               "/img/policy-endorsement.png",
               "PNG",
               pageConfig.leftMargin + 15,
               pageConfig.currentYpos,
               90,
               38
             );

             this.doFooter(doc, pageConfig, "Page 2 of 3");

             doc.addPage("a4", "p");

             this.doHeader(doc, pageConfig);

             pageConfig.currentYpos = pageConfig.topMargin;

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             pageConfig.currentYpos += 40;

             this.doHeading(doc, pageConfig, "SCHEDULE OF VEHICLES", 16);

             const scheduleColumnDefs = [
               {
                 label: "Item",
                 widthPercent: 10,
                 id: "item"
               },
               {
                 label: "Year",
                 widthPercent: 15,
                 id: "year"
               },
               {
                 label: "Model",
                 widthPercent: 15,
                 id: "model"
               },
               {
                 label: "Type",
                 widthPercent: 15,
                 id: "type"
               },

               {
                 label: "Rego",
                 widthPercent: 15,
                 id: "rego"
               },

               {
                 label: "Interested Parties",
                 widthPercent: 30,
                 id: "interestedParties"
               }
             ];

             const scheduleData = [];

             console.log(quoteModel.Ubind_quote_details_obj.formData);

             quoteModel.Ubind_quote_details_obj.formData.vehicles.forEach(
               (v, idx) => {
                 scheduleData.push({
                   item: (idx + 1).toString(),
                   year: v.displayYear,
                   make: v.displayMake,
                   model: v.displayModel,
                   type: "",
                   rego: v.vehicleRegistration,
                   interestedParties: v.interestedParties,
                   display: true,
                   rowHeight: 8
                 });
               }
             );

             this.doTable(doc, pageConfig, scheduleColumnDefs, scheduleData);

             this.doFooter(doc, pageConfig, "Page 3 of 3");

             //doc.save("policy-schedule.pdf");
             return doc;
           },

           generateInvoice(quoteModel) {
             const calculationResult = JSON.parse(
               quoteModel.Ubind_quote_details_obj.latestCalculationData
                 .calculationResultJson
             );

             const defaultPageWidth = 210;

             const pageConfig = {
               pageWidth: 210,
               contentWidth: 0,
               leftMargin: 20,
               rightMargin: 10,
               topMargin: 7,
               bottomMargin: 0,
               tableRowHeight: 7,
               currentYpos: 0
             };

             pageConfig.contentWidth =
               pageConfig.pageWidth - pageConfig.leftMargin;

             const doc = new jsPDF();

             //const pageWidth = 800;

             pageConfig.currentYpos += pageConfig.topMargin;

             this.doHeader(doc, pageConfig);

             doc.addImage(
               "/img/brand/mercurien_logo_300dpi.png",
               "PNG",
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               25,
               25
             );

             pageConfig.currentYpos += 40;

             this.doHeading(doc, pageConfig, "TAX INVOICE", 16);

             pageConfig.currentYpos += 10;

             this.doTextHeading(
               doc,
               pageConfig,
               "",
               "INVOICE NO " +
                 quoteModel.Ubind_quote_details_obj.policyNumber.replace(
                   "P-",
                   "INV-"
                 ),
               12,
               "normal",
               "bold"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "",
               "Invoice Date: " +
                 quoteModel.Ubind_quote_details_obj.formData.policyStartDate,
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 8;

             this.doTextHeading(
               doc,
               pageConfig,
               quoteModel.Ubind_quote_details_obj.formData.companyName,
               "For all enquiries, please contact:",
               10,
               "normal",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               quoteModel.Ubind_quote_details_obj.formData.contactAddressLine1,
               "E: support@mercurien.com",
               10,
               "normal",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               quoteModel.Ubind_quote_details_obj.formData
                 .contactAddressSuburb +
                 " " +
                 quoteModel.Ubind_quote_details_obj.formData
                   .contactAddressState +
                 " " +
                 quoteModel.Ubind_quote_details_obj.formData
                   .contactAddressPostcode,
               "W: www.mercurien.com",
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 8;

             this.doTextHeading(
               doc,
               pageConfig,
               "Insured:",
               quoteModel.Ubind_quote_details_obj.formData.companyName,
               10,
               "bold",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "Policy No:",
               quoteModel.Ubind_quote_details_obj.policyNumber,
               10,
               "bold",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "Insurer:",
               "HDI Global Specialty SE – Australia ABN 58 129 395 544, AFSL 458776",
               10,
               "bold",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "Ref no:",
               quoteModel.Ubind_quote_details_obj.quoteNumber,
               10,
               "bold",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "Period:",
               `From: 4PM (AEST) on ${quoteModel.Ubind_quote_details_obj.formData.policyStartDate} To: 4PM (AEST) on ${quoteModel.Ubind_quote_details_obj.formData.policyEndDate}`,
               10,
               "bold",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "Business:",
               "",
               10,
               "bold",
               "normal"
             );

             pageConfig.currentYpos += 5;

             doc.setFillColor("#efecf4");

             doc.rect(
               pageConfig.leftMargin,
               pageConfig.currentYpos,
               pageConfig.pageWidth - 40,
               72,
               "F"
             );

             pageConfig.currentYpos += 9;

             this.doTextHeading(
               doc,
               pageConfig,
               "Base Premium:",
               "$" + quoteModel.Ubind_quote_details_obj.premiumData.basePremium,
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "Policy Fee:",
               calculationResult.risk1.display.displayPolicyFee,
               10,
               "normal",
               "normal"
             );
             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "Administration Fee:",
               calculationResult.risk1.display.displayAdminFee,
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "FSL:",
               calculationResult.risk1.display.displayFsl,
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "Stamp Duty:",
               calculationResult.payment.priceComponents.stampDutyTotal,
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "driveX & Roadside:",
               calculationResult.payment.priceComponents.underwriterFee,
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "GST:",
               formattingMethods.formatCurrencyString(
                 parseFloat(
                   quoteModel.Ubind_quote_details_obj.premiumData.totalGst
                 )
               ),
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "Merchant Fee:",
               formattingMethods.formatCurrencyString(
                 parseFloat(
                   quoteModel.Ubind_quote_details_obj.premiumData.merchantFees
                 )
               ),
               10,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 2;

             this.doTextHeading(
               doc,
               pageConfig,
               "Total Amount:",
               formattingMethods.formatCurrencyString(
                 parseFloat(
                   quoteModel.Ubind_quote_details_obj.premiumData.totalPayable
                 )
               ),
               10,
               "bold",
               "bold"
             );

             pageConfig.currentYpos += 10;

             this.doTextHeading(
               doc,
               pageConfig,
               "(Upon payment of the Premium, this invoice will act as Your Tax Invoice)",
               "",
               8,
               "normal",
               "normal"
             );

             pageConfig.currentYpos += 5;

             this.doTextHeading(
               doc,
               pageConfig,
               "Details",
               "",
               8,
               "bold",
               "normal"
             );

             this.doTextHeading(
               doc,
               pageConfig,
               "We ask that You carefully check through Your coverage summary to ensure cover is as required.",
               "",
               8,
               "normal",
               "normal"
             );

             this.doFooter(doc, pageConfig, "Page 1 of 1");

             //doc.save("tax-invoice.pdf");
             return doc.output("datauristring");
           }
         }
       });
